import * as React from "react";
import * as ReactDOM from "react-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faUser } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { variables, validEmail } from '../Variables';
import { ConfirmSynchronization } from "./ConfirmSynchronization";
import { MultiSelect } from "react-multi-select-component";
import { WaitingListEnabledWindow } from "./WaitingListEnabledWindow";
import rightArrowWhite from "../assets/images/arrow-right-white.svg";
import { getEstateAndOfficeSettingAgentsite, getOfficesListFromlocalDB, saveAutomaticAcceptSetting, saveOfficesListInLocalDB } from "../services/commonService";
import { useRef } from "react";
import { arrayNoMatchingValues } from "../utils/commonService";
import { setcalendaractions } from "../features/ClientCalendarActionsSlice";
import { useDispatch } from "react-redux";
import { LabelUI } from "../ui/LabelUI";
import { setsetting } from "../features/SettingSlice";

const { useState } = React;

export const Settings = ({ showMessage, clientSettings }) => {
    const whiseUserToken = useSelector(state => state.whiseUser.whiseToken);
    const reduxClientToken = useSelector(state => state.whiseClientToken.whiseClientToken);
    const user = useSelector(state => state.user.user);
    const actions = useSelector(state => state.calendarActions.calendarActions);
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxSelectedLanguage = useSelector(state => state.selectedLanguageTranslations.selectedLanguage);
    const reduxProperty = useSelector(state => state.selectedProperty.selectedProperty);

    const [clientId, setClientId] = useState(user.user.clientId);
    const [officeId, setOfficeId] = useState(user.user.officeId);
    const [settingId, setSettingId] = useState("");
    const [office, setOffice] = useState({});
    const [calendarActions, setCalendarActions] = useState([]);
    const [saleVisitBefore, setSaleVisitBefore] = useState("");
    const [saleVisitAfter, setSaleVisitAfter] = useState("");
    const [rentVisitBefore, setRentVisitBefore] = useState("");
    const [rentVisitAfter, setRentVisitAfter] = useState("");
    const [rentVisitFreeSlot, setRentVisitFreeSlot] = useState("");
    const [saleVisitFreeSlot, setSaleVisitFreeSlot] = useState("");
    const [isSaleVisitBeforeEmpty, setIsSaleVisitBeforeEmpty] = useState("");
    const [isSaleVisitAfterEmpty, setIsSaleVisitAfterEmpty] = useState("");
    const [isRentVisitBeforeEmpty, setIsRentVisitBeforeEmpty] = useState("");
    const [isRentVisitAfterEmpty, setIsRentVisitAfterEmpty] = useState("");
    const [isSaleVisitFreeSlotEmpty, setIsSaleVisitFreeSlotEmpty] = useState("");
    const [isRentVisitFreeSlotEmpty, setIsRentVisitFreeSlotEmpty] = useState("");
    const [validationMessage, setValidationMessage] = useState("");
    const [isAcceptenceEmailDisabled, setIsAcceptenceEmailDisabled] = useState(false);
    const [isFreeSlotWhiseSyncEnabled, setIsFreeSlotWhiseSyncEnabled] = useState(false);
    const [officeList, setOfficeList] = useState([]);
    const [selectOffice, setSelectOffice] = useState("");
    const [file, setFile] = useState(null);
    const [uploadFileUrl, setUploadFileUrl] = useState(null);
    const [whiseAgents, setWhiseAgents] = useState([]);
    const [isManageVisitReqCustomEmail, setIsManageVisitReqCustomEmail] = useState(false);
    const [isSelectSpecificEmail, setIsSelectSpecificEmail] = useState("");
    const [isCustomEmail, setIsCustomEmail] = useState("");
    const [selectAgent, setSelectAgent] = useState("");
    const [isSelectSpecificEmailEmpty, setIsSelectSpecificEmailEmpty] = useState("");
    const [isSelectAgentEmpty, setIsSelectAgentEmpty] = useState("");
    const [isCustomEmailEmpty, setIsCustomEmailEmpty] = useState("");
    const [validationMessageEnableCustomEmail, setValidationMessageCustomEmail] = useState("");
    const [showConfirmationModel, setShowConfirmationModel] = useState(false);
    const [isSavedSyncingValueDifferent, setIsSavedSyncingValueDifferent] = useState(false);
    const [modalMessageLocalToWhiseSync, setModalMessageLocalToWhiseSync] = useState("");
    const [modalMessageWhiseToLocalSync, setModalMessageWhiseToLocalSync] = useState("");
    const [contactTitles, setContactTitles] = useState([]);
    const [contactTitlesEn, setContactTitlesEn] = useState([]);
    const [contactTitlesFr, setContactTitlesFr] = useState([]);
    const [contactTitlesNl, setContactTitlesNl] = useState([]);
    const [selectedTitles, setSelectedTitles] = useState([]);
    const [savedContactTitles, setSavedContactTitles] = useState("");
    const [isAutomaticSlotAccept, setIsAutomaticSlotAccept] = useState(false);
    const [isWaitingListEnabled, setIsWaitingListEnabled] = useState(false);
    const [waitingModalShow, setWaitingModalShow] = useState(false);
    const [waitingAlertMessage, setWaitingAlertMessage] = useState("");
    const [freeSlotVisibilityForSaleEstate, setFreeSlotVisibilityForSaleEstate] = useState("null");
    const [freeSlotVisibilityForRentEstate, setFreeSlotVisibilityForRentEstate] = useState("null");
    const [activeTab, setActiveTab] = useState("client");
    const [officeSetting, setOfficeSetting] = useState(null);
    const [fileName, setFileName] = useState("");
    const [automaticSlotSetupClientLevel, setAutomaticSlotSetupClientLevel] = useState(false);
    const [isWaitingListSetupClientLevel, setIsWaitingListSetupClientLevel] = useState(false);
    const [officeLanguage, setOfficeLanguage] = useState("fr-BE");
    const [officeLanguageSetupClientLevel, setOfficeLanguageSetupClientLevel] = useState(false);

    //On hold and deactive property status 
    const [estatePurposeStatusList, setEstatePurposeStatusList] = useState([]);
    const [selectDeactiveEstatePurposeStatus, setSelectDeactiveEstatePurposeStatus] = useState([]);
    const [selectEstatePurposeStatusListByOnHold, setSelectEstatePurposeStatusListByOnHold] = useState([]);
    const [cancelConfirmVisitOnHold, setCancelConfirmVisitOnHold] = useState(false);
    const [cancelConfirmVisitDeactive, setCancelConfirmVisitDeactive] = useState(true);
    const [notifyConfirmedVisitCancelOnHold, setNotifyConfirmedVisitCancelOnHold] = useState(true);
    const [notifyConfirmedVisitCancelDeactive, setNotifyConfirmedVisitCancelDeactive] = useState(true);
    const [isManagePropertyStatusChangeCustomEmail, setIsManagePropertyStatusChangeCustomEmail] = useState(false);
    const [isSelectSpecificEmailByPropertyStatus, setIsSelectSpecificEmailByPropertyStatus] = useState("");
    const [isCustomEmailByPropertyStatus, setIsCustomEmailByPropertyStatus] = useState("");
    const [isSelectSpecificEmailEmptyByPropertyStatus, setIsSelectSpecificEmailEmptyByPropertyStatus] = useState("");

    const [selectAgentByPropertyStatus, setSelectAgentByPropertyStatus] = useState("");
    const [isSelectAgentEmptyByPropertyStatus, setIsSelectAgentEmptyByPropertyStatus] = useState("");
    const [isCustomEmailEmptyByPropertyStatus, setIsCustomEmailEmptyByPropertyStatus] = useState("");
    const [timeDelayByPropertyStatus, setTimeDelayByPropertyStatus] = useState("5");
    const [cancelVisitCalanderActionId, setCancelVisitCalanderActionId] = useState("");
    const [isUniqueEstatePurposeConfigStatus, setIsUniqueEstatePurposeConfigStatus] = useState(false);
    const [isToggle, setIsToggle] = useState(false);
    const [enableEmailSentToContact, setEnableEmailSentToContact] = useState(false);
    const [onHoldEstateConfigValid, setOnHoldEstateConfigValid] = useState(false);
    const [deactiveEstateConfigValid, setDeactiveEstateConfigValid] = useState(false);
    const [deactiveEnableEmailSentToContact, setDeactiveEnableEmailSentToContact] = useState(false);
    const [confirmedVisitBackupMethod, setConfirmedVisitBackupMethod] = useState("delete_and_create");

    // Whise CRM email logging
    const [isEnableCrmEmailLogging, setIsEnableCrmEmailLogging] = useState(false);
    const [enableCustomCRMEmailLogging, setEnableCustomCRMEmailLogging] = useState(false);
    const [selectCRMEmailLoggingOption, setSelectCRMEmailLoggingOption] = useState("1");
    const [agentIdCRMEmailLogging, setAgentIdCRMEmailLogging] = useState("");
    const [isEmptyCrmEmailLoggingField, setIsEmptyCrmEmailLoggingField] = useState("");

    // Notification when property is switched to pending
    const [pendingRecipientOption, setPendingRecipientOption] = useState("1");
    const [pendingCustomRecipientType, setPendingCustomRecipientType] = useState("");
    const [pendingExceptionAgentId, setPendingExceptionAgentId] = useState("");
    const [pendingExceptionAgentEmail, setPendingExceptionAgentEmail] = useState("");
    const [pendingCustomTypeEmptyClass, setPendingCustomTypeEmptyClass] = useState("");
    const [pendingAgentEmptyClass, setPendingAgentEmptyClass] = useState("");
    const [pendingEmailEmptyClass, setPendingEmailEmptyClass] = useState("");
    const [validationMessagePendingNotification, setValidationMessagePendingNotification] = useState("");

    const [bookEventsShowOnBookingSite, setBookEventsShowOnBookingSite] = useState(false);

    const handlerPendingRecipientOption = (e) => {
        setPendingRecipientOption(e.target.value);

        if (e.target.value != 2) {
            setPendingCustomRecipientType("");
            setPendingExceptionAgentId("");
            setPendingExceptionAgentEmail("");
            setPendingCustomTypeEmptyClass("");
            setPendingAgentEmptyClass("");
            setPendingEmailEmptyClass("");
        }
    };

    const handlerPendingCustomRecipientType = (e) => {
        setPendingCustomRecipientType(e.target.value);
        setPendingCustomTypeEmptyClass("");

        if (e.target.value != 3) {
            setPendingExceptionAgentId("");
            setPendingExceptionAgentEmail("");
            setPendingAgentEmptyClass("");
            setPendingEmailEmptyClass("");
        }
    };

    const onChangePendingExceptionAgent = (e) => {
        setPendingExceptionAgentId(e.target.value);
        setPendingAgentEmptyClass("");
        if (e.target.value == "") setPendingExceptionAgentEmail("");
    };

    const onChangePendingExceptionEmail = (e) => {
        setPendingExceptionAgentEmail(e.target.value);
        setPendingEmailEmptyClass("");
    };

    const userAccountType = useSelector(state => state.userAccountType.userAccountType);
    const clientTokenByAccountType = useSelector(state => state.clientWhiseTokenByAccountType.clientWhiseTokenByAccountType);

    var scrollToElement = document.getElementById("visitToSaleBefore");
    const fileInputRef = useRef(null);

    const dispatch = useDispatch();
    //get client language
    const getClientDefaultLanguageFromWhise = async () => {
        try {
            let url = "https://api.whise.eu/v1/admin/clients/settings";
            const config = {
                headers: {
                    'Authorization': `Bearer ${reduxClientToken}`,
                    'Content-Type': 'application/json'
                },
            };
            const response = await axios.post(url, { ClientId: clientId }, config);
            let langId = response.data?.settings?.defaultLanguageId;
            if (langId) {
                return langId.toLowerCase() === "nl-nl" ? "nl-BE" : langId;
            }
        } catch (error) {
            console.log("getClientDefaultLanguageFromWhise error:", error);
        }
        return "en-GB";
    }

    useEffect(() => {
        if (reduxClientToken && reduxSelectedLanguage) {
            getCalendarActions(reduxClientToken, reduxSelectedLanguage);
        }
    }, [reduxClientToken, reduxSelectedLanguage]);

    const getCalendarActions = (clientToken, languageId) => {
        let url = "https://api.whise.eu/v1/calendars/actions/list";

        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, { "LanguageId": languageId }, config)
            .then(response => {
                dispatch(
                    setcalendaractions(response.data.calendarActions)
                );
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const getWhiseOffices = async () => {
        let url = "https://api.whise.eu/v1/admin/offices/list";

        const config = {
            headers: {
                'Authorization': `Bearer ${whiseUserToken}`,
                'Content-Type': 'application/json'
            },
        };

        //await axios.post(url, { }, config)
        await axios.post(url, { "clientId": clientId }, config)
            .then(response => {
                if (response.data.offices != undefined) {
                    const updateOfficeList = response.data.offices.map((item) => ({ ...item, Id: item.id }));
                    setOfficeList(updateOfficeList);
                    //setOfficeList(response.data.offices);
                    var _filteredOffice = updateOfficeList.filter((item) => { return item.id == officeId });
                    setOffice(_filteredOffice[0]);
                    setSelectOffice(_filteredOffice[0].id);
                    getOfficesLogo(_filteredOffice[0].id);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const changeHandlerFreeSlotWhiseSynchronization = (e) => {
        setModalMessageLocalToWhiseSync(reduxLanguageTranslations ? reduxLanguageTranslations["featureTemporarilyDisabled"] : "This feature is temporariliy is disabled");
        /*  let checked = e.target.checked;
          if (checked) {
              setModalMessageLocalToWhiseSync(reduxLanguageTranslations ? reduxLanguageTranslations["confirmLocalToWhiseSyncMessage"] : "All the existing free slot will be synchronised in WHISE in the calendar of the agents. Note that we will only synchronise the free slot created on the next two months.");
          }
          else {
              setModalMessageWhiseToLocalSync(reduxLanguageTranslations ? reduxLanguageTranslations["confirmWhiseToLocalSyncMessage"] : "All the existing free slot in WHISE will be deleted from the agendas for the next 90 days. Free slots that are existing above this time will have to be deleted manually from the agendas.");
          }
           */
        setShowConfirmationModel(true);
    }
    const onChangeOfficeLanguage = (e) => {
        setOfficeLanguage(e.target.value);
    };

    const handlerSaveSetting = async (e) => {
        e.target.setAttribute("disabled", true);
        e.target.style.cursor = "progress";
        document.querySelector("body").style.cursor = "progress";
        setValidationMessage("");
        setValidationMessageCustomEmail("");
        setValidationMessagePendingNotification("");
        let flagEmpty = false;
        let flagEmptyEnableCustomEmail = false;
        let flagEmptyEnableOnHoldDeactivePropertyStatus = false;
        let flagEmptyPendingNotification = false;
        if (saleVisitBefore == "") {
            setIsSaleVisitBeforeEmpty("empty");
            flagEmpty = true;
        }
        if (saleVisitAfter == "") {
            setIsSaleVisitAfterEmpty("empty");
            flagEmpty = true;
        }
        if (rentVisitBefore == "") {
            setIsRentVisitBeforeEmpty("empty");
            flagEmpty = true;
        }
        if (rentVisitAfter == "") {
            setIsRentVisitAfterEmpty("empty");
            flagEmpty = true;
        }
        if (rentVisitFreeSlot == "") {
            setIsRentVisitFreeSlotEmpty("empty");
            flagEmpty = true;
        }
        if (saleVisitFreeSlot == "") {
            setIsSaleVisitFreeSlotEmpty("empty");
            flagEmpty = true;
        }
        if ((isSelectSpecificEmail == "" || isSelectSpecificEmail == null) && isManageVisitReqCustomEmail) {
            setIsSelectSpecificEmailEmpty("empty");
            flagEmptyEnableCustomEmail = true;
        }
        if ((isCustomEmail == "" || isCustomEmail == null) && isManageVisitReqCustomEmail && isSelectSpecificEmail == 2) {
            setIsCustomEmailEmpty("empty");
            flagEmptyEnableCustomEmail = true;
        }
        if ((isCustomEmail == "" || isCustomEmail == null) && isManageVisitReqCustomEmail && isSelectSpecificEmail == 2) {
            setIsCustomEmailEmpty("empty");
            flagEmptyEnableCustomEmail = true;
        }
        if ((selectAgent == "" || selectAgent == null) && isManageVisitReqCustomEmail && isSelectSpecificEmail == 2) {
            setIsSelectAgentEmpty("empty");
            flagEmptyEnableCustomEmail = true;
        }

        // validation on hold and deactive fields
        if ((isSelectSpecificEmailByPropertyStatus == "" || isSelectSpecificEmailByPropertyStatus == null) && isManagePropertyStatusChangeCustomEmail) {
            setIsSelectSpecificEmailEmptyByPropertyStatus("empty");
            flagEmptyEnableOnHoldDeactivePropertyStatus = true;
        }
        if ((selectAgentByPropertyStatus == "" || selectAgentByPropertyStatus == null) && isSelectSpecificEmailByPropertyStatus == 2 && isManagePropertyStatusChangeCustomEmail) {
            setIsSelectAgentEmptyByPropertyStatus("empty");
            flagEmptyEnableOnHoldDeactivePropertyStatus = true;
        }
        if ((isCustomEmailByPropertyStatus == "" || isCustomEmailByPropertyStatus == null) && isSelectSpecificEmailByPropertyStatus == 2 && isManagePropertyStatusChangeCustomEmail) {
            setIsCustomEmailEmptyByPropertyStatus("empty");
            flagEmptyEnableOnHoldDeactivePropertyStatus = true;
        }

        // check unique status for (onhold & deactive) estate purpose config
        const getUniquneEstatePurposeConfigValues = await arrayNoMatchingValues(selectEstatePurposeStatusListByOnHold, selectDeactiveEstatePurposeStatus);

        // validation unique status on hold and deactive estate purpose config
        if (getUniquneEstatePurposeConfigValues) {
            setIsUniqueEstatePurposeConfigStatus(true);
            const alertText = reduxLanguageTranslations ? reduxLanguageTranslations["duplicateStatusDetectedError"] : "Duplicate status detected. Please ensure ‘Statuses Triggering Property On Hold’ and ‘Statuses Triggering Property Deactivated’ use different purpose statuses.";
            showMessage("error", alertText);
            flagEmptyEnableOnHoldDeactivePropertyStatus = true;
        }

        // validation please choose one status from onhold and deactive estate list
        if (selectEstatePurposeStatusListByOnHold == 0 && selectDeactiveEstatePurposeStatus == 0) {
            const alertText = reduxLanguageTranslations ? reduxLanguageTranslations["chooseEstateDeactivatedStatusConfig"] : "Please select the estate status configuration: On Hold or Deactivated.";
            showMessage("error", alertText);
            setDeactiveEstateConfigValid(true);
            setOnHoldEstateConfigValid(true);
            flagEmptyEnableOnHoldDeactivePropertyStatus = true;
        }

        // Crm Email Logging
        if (isEnableCrmEmailLogging && selectCRMEmailLoggingOption != 1 && agentIdCRMEmailLogging == "") {
            setIsEmptyCrmEmailLoggingField("empty");
            const alertText = selectCRMEmailLoggingOption == 2 ? (reduxLanguageTranslations ? reduxLanguageTranslations["pleaseEnterUserIdForCrmEmailLogging"] : "Please Select the Agent for CRM Email Logging") : (reduxLanguageTranslations ? reduxLanguageTranslations["pleaseSelectAgentForCrmEmailLogging"] : "Please Select the Agent for CRM Email Logging" );
            showMessage("error", alertText);
            flagEmptyEnableOnHoldDeactivePropertyStatus = true;
        }
        // validation: notification when property is switched to pending
        if (pendingRecipientOption == 2) {
            if (pendingCustomRecipientType == "" || pendingCustomRecipientType == null) {
                setPendingCustomTypeEmptyClass("empty");
                flagEmptyPendingNotification = true;
            }
            if (pendingCustomRecipientType == 3) {
                if (pendingExceptionAgentId == "" || pendingExceptionAgentId == null) {
                    setPendingAgentEmptyClass("empty");
                    flagEmptyPendingNotification = true;
                }
                if (pendingExceptionAgentEmail == "" || pendingExceptionAgentEmail == null) {
                    setPendingEmailEmptyClass("empty");
                    flagEmptyPendingNotification = true;
                }
            }
        }
        if (flagEmpty == true) {
            setValidationMessage(reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageRequiredFieldsMessage"] : "Please fill the required fields");
            scrollToElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            e.target.removeAttribute("disabled");
            e.target.style.cursor = "";
            document.querySelector("body").style.cursor = "";
            return;
        }

        if (flagEmptyEnableCustomEmail == true) {
            setValidationMessageCustomEmail(reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageRequiredFieldsMessage"] : "Please fill the required fields");
            scrollToElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            e.target.removeAttribute("disabled");
            e.target.style.cursor = "";
            document.querySelector("body").style.cursor = "";
            return;
        }
        if (flagEmptyPendingNotification == true) {
            setValidationMessagePendingNotification(reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageRequiredFieldsMessage"] : "Please fill the required fields");
            scrollToElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            e.target.removeAttribute("disabled");
            e.target.style.cursor = "";
            document.querySelector("body").style.cursor = "";
            return;
        }

        if (flagEmptyEnableOnHoldDeactivePropertyStatus == true) {
            e.target.removeAttribute("disabled");
            e.target.style.cursor = "";
            document.querySelector("body").style.cursor = "";
            return;
        }

        if (isSavedSyncingValueDifferent != isFreeSlotWhiseSyncEnabled) {
            if (isFreeSlotWhiseSyncEnabled) {
                await moveLocalEventsToWhise([+rentVisitFreeSlot, +saleVisitFreeSlot]);
            }
            else {
                await moveWhiseEventsToLocal([+rentVisitFreeSlot, +saleVisitFreeSlot]);
            }
        }
        
        //const selectedIds = selectedTitles?.map(item => item.value) || [];
        const commaSeparatedTitleIds = selectedTitles.length > 0 ? JSON.stringify(selectedTitles) : ""; //selectedIds.length > 0 ? selectedIds.join(',') : null;

        let settingsObj = {
            "SettingId": settingId == "" ? 0 : +settingId,
            "VisitToSaleBefore": +saleVisitBefore,
            "VisitToSaleAfter": +saleVisitAfter,
            "VisitToRentBefore": +rentVisitBefore,
            "VisitToRentAfter": +rentVisitAfter,
            "VisitToRentFreeSlot": +rentVisitFreeSlot,
            "VisitToSaleFreeSlot": +saleVisitFreeSlot,
            "OfficeId": +officeId,
            "IsAcceptenceEmailDisabled": isAcceptenceEmailDisabled,
            "SyncEventsToWhise": isFreeSlotWhiseSyncEnabled,
            "IsVisitRequestManagementEnabled": isManageVisitReqCustomEmail ? isManageVisitReqCustomEmail : null,
            "SendEmailTo": isManageVisitReqCustomEmail ? isSelectSpecificEmail : null,
            "CustomEmail": isManageVisitReqCustomEmail && isSelectSpecificEmail == 2 ? isCustomEmail : null,
            "MappedContactTitles": commaSeparatedTitleIds,
            //"OfficesDetail": JSON.stringify(officeList),
            "automaticSlotAcceptation": isAutomaticSlotAccept,
            "waitingListEnabled": isWaitingListEnabled,
            "FreeslotManagementForSale": freeSlotVisibilityForSaleEstate,
            "FreeslotManagementForRent": freeSlotVisibilityForRentEstate,
            PurposeStatusChangeSetting: isToggle,
            ShowBookedSlots: bookEventsShowOnBookingSite,
            //new enter on hold and deactive
            OnholdStatusConfiguration: JSON.stringify({
                mappingStatus: selectEstatePurposeStatusListByOnHold,
                onHoldCancelConfirmedVisits: cancelConfirmVisitOnHold,
                confirmationContactEmail: notifyConfirmedVisitCancelOnHold,
                notifyToWaitingList: enableEmailSentToContact
            }),
            DeactivatedStatusConfiguration: JSON.stringify({
                mappingStatus: selectDeactiveEstatePurposeStatus, // [{ id: 1 }, { id: 2 }]
                deactivatedCancelConfirmedVisits: cancelConfirmVisitDeactive,
                confirmationContactEmail: notifyConfirmedVisitCancelDeactive,
                notifyToWaitingList: deactiveEnableEmailSentToContact
            }),
            CommonConfigurationOnholdDeactivated: JSON.stringify({
                crmDeletedVisitActionId: cancelVisitCalanderActionId != "" ? +cancelVisitCalanderActionId : null,
                statusChangeExecDelayMinutes: timeDelayByPropertyStatus != "" ? +timeDelayByPropertyStatus : 5,
                confirmedVisitBackupMethod: confirmedVisitBackupMethod,
                agencyStatusChangeNotificationRecipients: {
                    enableEmailChecked: isManagePropertyStatusChangeCustomEmail,
                    sendEmailTo: isManagePropertyStatusChangeCustomEmail && isSelectSpecificEmailByPropertyStatus != "" ? isSelectSpecificEmailByPropertyStatus : null,
                    agentCustomEmail: isManagePropertyStatusChangeCustomEmail && isCustomEmailByPropertyStatus != "" ? isCustomEmailByPropertyStatus : null,
                    customAgentId: isManagePropertyStatusChangeCustomEmail && selectAgentByPropertyStatus != "" ? selectAgentByPropertyStatus : null
                }
            }),

            // crm email logging // "SystemIntegrator"
            IsWhiseEmailLoggingEnabled: userAccountType == variables.UserAccountTypeIdentity ? isEnableCrmEmailLogging : false,
            whiseLoggingAgentConfig: isEnableCrmEmailLogging ? JSON.stringify({
                id: selectCRMEmailLoggingOption,
                type: selectCRMEmailLoggingOption == 1 ? "Estate representative" : selectCRMEmailLoggingOption == 2 ? "Specific user" : "Agent from office list",
                userId: selectCRMEmailLoggingOption == 1 ? null : agentIdCRMEmailLogging
            }) : null,
            PendingNotificationConfiguration: JSON.stringify({
                recipientOption: pendingRecipientOption != "" ? +pendingRecipientOption : null,
                customRecipientType: pendingRecipientOption == 2 && pendingCustomRecipientType != "" ? +pendingCustomRecipientType : null,
                exceptionAgentId: pendingRecipientOption == 2 && pendingCustomRecipientType == 3 && pendingExceptionAgentId != "" ? +pendingExceptionAgentId : null,
                exceptionAgentEmail: pendingRecipientOption == 2 && pendingCustomRecipientType == 3 && pendingExceptionAgentEmail != "" ? pendingExceptionAgentEmail : null
            }),
        }

        if (isManageVisitReqCustomEmail && selectAgent) {
            settingsObj["ReqManagementOfAgent"] = selectAgent;
        }
        //console.log(settingsObj);
        let url = variables.API_URL + `Settings/SaveSetting?clientId=${clientId}`;

        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        axios.post(url, JSON.stringify(settingsObj), jsonconfig) // ASP.NET Core API endpoint with header
            .then(response => {
                if (response.status == 200) {
                    setIsSavedSyncingValueDifferent(isFreeSlotWhiseSyncEnabled)
                    showMessage("success", response.data);
                    //saveAndUpdateOfficeLog();
                    e.target.removeAttribute("disabled");
                    e.target.style.cursor = "";
                    document.querySelector("body").style.cursor = "";
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                e.target.removeAttribute("disabled");
                e.target.style.cursor = "";
                document.querySelector("body").style.cursor = "";
            });
    }

    const moveLocalEventsToWhise = async (freeSlotIds) => {
        const now = new Date();
        // Set startDate to today at 12:00:00 AM
        const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
        // Set endDate to the last second of the same day two months later
        const endDate = new Date(now.getFullYear(), now.getMonth() + 3, now.getDate(), 23, 59, 59);

        let calendarActions = [...new Set([...freeSlotIds])];
        let localEvents = await getCalendarEventsFromDB(startDate, endDate, calendarActions);

        let eventIdsToRemove = [];

        if (localEvents.isValidRequest && localEvents.totalCount > 0) {
            // Use map to create an array of promises and await all of them
            await Promise.all(localEvents.calendars.map(async (event) => {
                let configration = {
                    CalendarActionId: event.calendarActionId,
                    StartDateTime: event.startDateTime,
                    EndDateTime: event.endDateTime,
                    AllDay: event.allDay,
                    Private: false,
                    Subject: event.subject,
                    UserIds: [event.userId],
                    EstateIds: [event.estateId],
                    ContactIds: [event.contactId],
                    Description1: event.description1
                };

                if (event.contactId) {
                    configration["ContactIds"] = [event.contactId];
                }
                else {
                    configration["ContactIds"] = [+user.user.contactId];
                }

                let calendarId = await addWhiseCalenderEvent(configration);

                if (calendarId) {
                    eventIdsToRemove.push(event.id);
                }
            }));

            // Now this will only run after all event IDs have been pushed
            if (eventIdsToRemove.length > 0) {
                await deleteCalendarEventFromDB(eventIdsToRemove);
            }
        }
    };

    //Get events saved in local database
    const getCalendarEventsFromDB = async (startDate, endDate, calendarActions) => {
        // Generate query string
        let payload = {
            clientId: clientId,
            startDate: startDate,
            endDate: endDate,
            calendarActions: `${calendarActions}`
        };

        let url = variables.API_URL + `LocalEvents/GetLocalEventsForSynching?`;

        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, JSON.stringify(payload), config);

        return response.data;
    }

    const addWhiseCalenderEvent = async (body) => {
        let url = "";
        let config = null;

        try {
            if (userAccountType == variables.UserAccountTypeIdentity) { // "SystemIntegrator"
                url = "https://api.whise.eu/v1/calendars/create";

                config = {
                    headers: {
                        'Authorization': `Bearer ${clientTokenByAccountType}`,
                        'Content-Type': 'application/json'
                    },
                };
            } else {

                url = "https://api.whise.eu/v1/calendars/upsert";

                config = {
                    headers: {
                        'Authorization': `Bearer ${reduxClientToken}`,
                        'Content-Type': 'application/json'
                    },
                };
            }

            let response = await axios.post(url, body, config);
            return response.data.calendarId;
        } catch (error) {
            console.log(error);
        }
    }

    const deleteCalendarEventFromDB = async (_eventIds) => {

        let url = variables.API_URL + `LocalEvents/DeleteEventsByIdWhileSync?`;

        let payload = {
            eventIds: _eventIds
        };

        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, payload, config);

        return response.data;
    }

    const moveWhiseEventsToLocal = async (freeSlotIds) => {
        const now = new Date();
        // Set startDate to today at 12:00:00 AM
        const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
        // Set endDate to the last second of the same day two months later
        const endDate = new Date(now.getFullYear(), now.getMonth() + 3, now.getDate(), 23, 59, 59);

        let calendarActions = [...new Set([...freeSlotIds])];
        let whiseEvents = await getWhiseCalendarEvents(startDate, endDate, calendarActions);

        if (whiseEvents.length > 0) {
            whiseEvents.forEach(async event => {
                let configration = {
                    StartDateTime: event.startDateTime,
                    EndDateTime: event.endDateTime,
                    AllDay: false,
                    Private: false,
                    Subject: event.subject
                };

                if (event.action) {
                    configration["CalendarActionId"] = event.action.id;
                }

                if (event.allDay) {
                    configration["AllDay"] = event.allDay;
                }

                if (event.estates) {
                    configration["EstateIds"] = [event.estates[0].estateId]
                }

                if (event.users) {
                    configration["UserIds"] = [event.users[0].userId]
                }

                if (event.contacts) {
                    configration["ContactIds"] = [event.contacts[0].contactId]
                }

                if (event.description1) {
                    configration["Description1"] = event.description1;
                }

                let calendarId = await addCalenderEventInDB(configration, event.id);

                if (calendarId) {
                    await deleteWhiseCalendarEvent(event.id);
                }
            })
        }
    }

    //Fetch events for selected estate from whise and DB
    const getWhiseCalendarEvents = async (startDate, endDate, calendarActions) => {
        var eventLimit = 300;
        var pageOffset = 0;
        let listOfEvents = [];

        let _response = await getWhiseCalendarEventsByPagination(eventLimit, pageOffset, startDate, endDate, calendarActions);

        if (_response.totalCount != undefined && _response.totalCount > 300) {
            listOfEvents.push(..._response.calendars);
            let _afterDivison = _response.totalCount / 300;
            let pages = Math.ceil(_afterDivison);
            for (let i = 1; i < pages; i++) {
                pageOffset = eventLimit * i + 1;
                let _eventResponse = await getWhiseCalendarEventsByPagination(eventLimit, pageOffset, startDate, endDate, calendarActions);
                if (_eventResponse.calendars != undefined && _eventResponse.calendars.length > 0) {
                    listOfEvents.push(..._eventResponse.calendars);
                }
            }
        }
        else if (_response.calendars != undefined && _response.calendars.length > 0) {
            listOfEvents.push(..._response.calendars);
        }

        return listOfEvents;
    }

    //Get events from whise with pagination
    //This method will hit twice if in first call event count is greater than 300
    const getWhiseCalendarEventsByPagination = async (eventLimit, pageOffset, startDate, endDate, calendarActions) => {

        let url = "https://api.whise.eu/v1/calendars/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${reduxClientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let body = {
            "Filter": {
                "DateTimeRange": {
                    "Min": startDate,
                    "Max": endDate
                },
                "CalendarActionIds": calendarActions
            },
            "Page": {
                "Limit": eventLimit,
                "Offset": pageOffset
            }
        };

        let response = await axios.post(url, body, config);

        return response.data;
    }

    const addCalenderEventInDB = async (body, whiseEventId) => {
        let url = variables.API_URL + "LocalEvents/SaveEventInDatabase?";
        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };
        body.ClientId = clientId;

        //axios.post(url, body, config)
        //    .then(response => {
        //        if (response.data.calendarId != undefined) {
        //            deleteWhiseCalendarEvent(whiseEventId);
        //        }
        //    })
        //    .catch(error => {
        //        showMessage("error", error);
        //    });

        let response = await axios.post(url, body, config);
        return response.data.calendarId;
    }

    const deleteWhiseCalendarEvent = async (eventId) => {

        let url = "https://api.whise.eu/v1/calendars/delete";
        let headers = {
            'Authorization': `Bearer ${reduxClientToken}`,
            'Content-Type': 'application/json'
        };
        let body = {
            "CalendarIds": [+eventId]
        };

        let response = await axios.delete(url, { data: body, headers: headers });

        return response.data;
    }

    const handlerVisitToSaleBefore = (e) => {
        setSaleVisitBefore(e.target.value);
        setIsSaleVisitBeforeEmpty("");
    }

    const handlerVisitToSaleAfter = (e) => {
        setSaleVisitAfter(e.target.value);
        setIsSaleVisitAfterEmpty("");
    }

    const handlerVisitToRentBefore = (e) => {
        setRentVisitBefore(e.target.value);
        setIsRentVisitBeforeEmpty("");
    }

    const handlerVisitToRentAfter = (e) => {
        setRentVisitAfter(e.target.value);
        setIsRentVisitAfterEmpty("");
    }

    const handlerVisitToSaleFreeSlot = (e) => {
        setSaleVisitFreeSlot(e.target.value);
        setIsSaleVisitFreeSlotEmpty("");
    }

    const handlerVisitToRentFreeSlot = (e) => {
        setRentVisitFreeSlot(e.target.value);
        setIsRentVisitFreeSlotEmpty("");
    }

    const handlerResetSettings = () => {
        setSaleVisitBefore("");
        setSaleVisitAfter("");
        setRentVisitBefore("");
        setRentVisitAfter("");
        setSaleVisitFreeSlot("");
        setRentVisitFreeSlot("");
        setIsSaleVisitBeforeEmpty("");
        setIsSaleVisitAfterEmpty("");
        setIsRentVisitBeforeEmpty("");
        setIsRentVisitAfterEmpty("");
        setIsSaleVisitFreeSlotEmpty("");
        setIsRentVisitFreeSlotEmpty("");
        setValidationMessage("");
        setIsManageVisitReqCustomEmail(false);
        setIsSelectSpecificEmail("");
        setIsCustomEmail("");
        setSelectAgent("");
        setValidationMessageCustomEmail("");
        scrollToElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }

    // get client setting from local db
    const getOfficeSettings = () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/GetSetting?officeId=` + officeId;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                if (response.data != null) {
                    let settings = response.data;
                    setOfficeSetting(settings);
                    dispatch(setsetting(settings));
                    setSettingId(settings.settingId);
                    setSaleVisitBefore(settings.visitToSaleBefore);
                    setSaleVisitAfter(settings.visitToSaleAfter);
                    setRentVisitBefore(settings.visitToRentBefore);
                    setRentVisitAfter(settings.visitToRentAfter);
                    setRentVisitFreeSlot(settings.visitToRentFreeSlot);
                    setSaleVisitFreeSlot(settings.visitToSaleFreeSlot);
                    setIsAcceptenceEmailDisabled(settings.isAcceptenceEmailDisabled == null ? false : settings.isAcceptenceEmailDisabled);
                    setIsFreeSlotWhiseSyncEnabled(settings.syncEventsToWhise == null ? false : settings.syncEventsToWhise);
                    setIsSavedSyncingValueDifferent(settings.syncEventsToWhise == null ? false : settings.syncEventsToWhise);
                    setIsManageVisitReqCustomEmail(settings.isVisitRequestManagementEnabled);
                    setIsSelectSpecificEmail(settings.sendEmailTo);
                    setIsCustomEmail(settings.customEmail);
                    setSelectAgent(settings.reqManagementOfAgent);
                    setSavedContactTitles(settings.mappedContactTitles);
                    setIsAutomaticSlotAccept(settings.automaticSlotAcceptation);
                    setIsWaitingListEnabled(settings.waitingListEnabled);
                    setFreeSlotVisibilityForSaleEstate(settings.freeslotManagementForSale);
                    setFreeSlotVisibilityForRentEstate(settings.freeslotManagementForRent);
                    setIsToggle(settings.purposeStatusChangeSetting);
                    setBookEventsShowOnBookingSite(settings.showBookedSlots);
                    //console.log(settings);

                    // on hold property status configuration
                    let deserializeOnHoldProperty = JSON.parse(settings.onholdStatusConfiguration);
                    if (deserializeOnHoldProperty != null) {
                        setCancelConfirmVisitOnHold(deserializeOnHoldProperty.onHoldCancelConfirmedVisits);
                        setNotifyConfirmedVisitCancelOnHold(deserializeOnHoldProperty.confirmationContactEmail);
                        setSelectEstatePurposeStatusListByOnHold(deserializeOnHoldProperty.mappingStatus);
                        setEnableEmailSentToContact(deserializeOnHoldProperty.notifyToWaitingList);
                    }

                    // deactive property status configuration
                    let deserializeDeactiveProperty = JSON.parse(settings.deactivatedStatusConfiguration);
                    if (deserializeDeactiveProperty != null) {
                        setCancelConfirmVisitDeactive(deserializeDeactiveProperty.deactivatedCancelConfirmedVisits);
                        setNotifyConfirmedVisitCancelDeactive(deserializeDeactiveProperty.confirmationContactEmail);
                        setSelectDeactiveEstatePurposeStatus(deserializeDeactiveProperty.mappingStatus);
                        setDeactiveEnableEmailSentToContact(deserializeDeactiveProperty.notifyToWaitingList);
                    }

                    // common on hold and deactive property status configuration
                    let deserializeCommonOnHoldDeactiveProperty = JSON.parse(settings.commonConfigurationOnholdDeactivated);
                    if (deserializeCommonOnHoldDeactiveProperty != null) {
                        const crmCancelCalanderActionId = deserializeCommonOnHoldDeactiveProperty.crmDeletedVisitActionId != null ?
                            deserializeCommonOnHoldDeactiveProperty.crmDeletedVisitActionId : "";

                        const specificeEmailSendTo = deserializeCommonOnHoldDeactiveProperty.agencyStatusChangeNotificationRecipients.sendEmailTo != null ?
                            deserializeCommonOnHoldDeactiveProperty.agencyStatusChangeNotificationRecipients.sendEmailTo : "";

                        const agentCustomEmailByPropertyStatus = deserializeCommonOnHoldDeactiveProperty.agencyStatusChangeNotificationRecipients.agentCustomEmail != null ?
                            deserializeCommonOnHoldDeactiveProperty.agencyStatusChangeNotificationRecipients.agentCustomEmail : "";

                        const customAgentIdByPropertyStatus = deserializeCommonOnHoldDeactiveProperty.agencyStatusChangeNotificationRecipients.customAgentId != null ?
                            deserializeCommonOnHoldDeactiveProperty.agencyStatusChangeNotificationRecipients.customAgentId : "";
                        
                        setCancelVisitCalanderActionId(crmCancelCalanderActionId);
                        setTimeDelayByPropertyStatus(deserializeCommonOnHoldDeactiveProperty.statusChangeExecDelayMinutes);
                        setIsManagePropertyStatusChangeCustomEmail(deserializeCommonOnHoldDeactiveProperty.agencyStatusChangeNotificationRecipients.enableEmailChecked);
                        setIsSelectSpecificEmailByPropertyStatus(specificeEmailSendTo);
                        setIsCustomEmailByPropertyStatus(agentCustomEmailByPropertyStatus);
                        setSelectAgentByPropertyStatus(customAgentIdByPropertyStatus);
                        setConfirmedVisitBackupMethod(deserializeCommonOnHoldDeactiveProperty.confirmedVisitBackupMethod);
                    }

                    // CRM Email Logging
                    setIsEnableCrmEmailLogging(settings.isWhiseEmailLoggingEnabled);
                    let deserializeCRMEmailLogging = JSON.parse(settings.whiseLoggingAgentConfig);
                    if (deserializeCRMEmailLogging) {
                        setSelectCRMEmailLoggingOption(deserializeCRMEmailLogging?.id ?? "1");
                        setAgentIdCRMEmailLogging(deserializeCRMEmailLogging?.userId ?? "");
                        setEnableCustomCRMEmailLogging(true);
                    }
                    // notification when property is switched to pending
                    if (settings.pendingNotificationConfiguration) {
                        try {
                            const pendingConfig = JSON.parse(settings.pendingNotificationConfiguration);

                            setPendingRecipientOption(pendingConfig.recipientOption != null ? String(pendingConfig.recipientOption) : "1");
                            setPendingCustomRecipientType(pendingConfig.customRecipientType != null ? String(pendingConfig.customRecipientType) : "");
                            setPendingExceptionAgentId(pendingConfig.exceptionAgentId != null ? String(pendingConfig.exceptionAgentId) : "");
                            setPendingExceptionAgentEmail(pendingConfig.exceptionAgentEmail ?? "");
                        } catch (e) {
                            console.error("Invalid pendingNotificationConfiguration", e);
                        }
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const handlerSelectOffice = (e) => {
        const value = e.target.value;
        setSelectOffice(value);
        if (value != "") {
            let _filteredOffice = officeList.filter((item) => item.Id == value || item.id == value);
            setOffice(_filteredOffice[0]);
            getOfficesLogo(_filteredOffice[0].Id || _filteredOffice[0].id);
        }
    }

    const getOfficesLogo = (_officeId) => {

        let url = "";
        if (_officeId) {
            url = `${variables.API_URL}Settings/GetLogoByOfficeId/${_officeId}`;
        }
        else {
            url = `${variables.API_URL}Settings/GetLogoByOfficeId/${office.id || officeId}`;
        }

        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        axios.get(url, {}, config)
            .then(response => {
                const value = response.data;
                let imgUrl = ""
                if (value && value.logoUrl) {
                    let fileName = value.logoUrl.split("UploadedFiles/")[1];
                    imgUrl = `${variables.API_URL.split("/api")[0]}/UploadedFiles/${fileName}`;
                    setFile(imgUrl);
                    setUploadFileUrl(value.logoUrl);
                }
                else {
                    setFile("");
                    setUploadFileUrl("");
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const handlerSelectSpecificEmail = (e) => {
        const value = e.target.value;
        setIsSelectSpecificEmail(value);
        if (value == 2) {
            setIsCustomEmail("");
        }
        setIsSelectSpecificEmailEmpty("");
    }

    const handlerSelectAgent = (e) => {
        const value = e.target.value;
        setSelectAgent(value);
        setIsSelectAgentEmpty("");
    }

    const handlerCustomEmail = (e) => {
        const value = e.target.value;
        setIsCustomEmail(value);
        setIsCustomEmailEmpty("");
    }

    const handlerEnableVisitReqCheckbox = (e) => {
        const value = e.target.checked;
        setIsManageVisitReqCustomEmail(value);
        if (value == true) {
            setIsSelectSpecificEmail("");
            setIsCustomEmail("");
            setSelectAgent("");
        }
    }

    const handlerChangeUploadOfficeLogo = async (e) => {
        const uploadFile = e.target.files[0];
        setFile(URL.createObjectURL(e.target.files[0]));

        const formData = new FormData();
        formData.append("files", uploadFile);
        formData.append("fileName", uploadFile.name);
        setFileName(uploadFile.name);
        try {
            const url = `${variables.API_URL}DocumentUpload/UploadOfficeLogo`;
            const response = await axios.post(url, formData, {
                headers: {
                    Authorization: `Bearer ${user.tokenValue}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            setUploadFileUrl(response.data.urls[0]);
        } catch (error) {
            console.error("Upload error:", error);
        }
    }

    const saveAndUpdateOfficeLog = async () => {

        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/SaveOrUpdateLogo`;

        const obj = {
            officeId: office.Id,
            logoUrl: uploadFileUrl
        }

        try {
            const response = await axios.post(url, obj, jsonconfig);
            const value = response.data;
        } catch (error) {
            console.error("Upload error:", error);
        }
    }

    const getAgents = async () => {
        let url = "https://api.whise.eu/v1/admin/representatives/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${reduxClientToken}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, {}, config)
            .then(response => {
                setWhiseAgents(response.data.representatives);
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const getContactTitlesEn = async () => {
        let url = "https://api.whise.eu/v1/contacts/titles/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${reduxClientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let body = {
            LanguageId: "en-GB"
        }

        axios.post(url, body, config)
            .then(response => {
                if (response.data.isValidRequest) {
                    setContactTitlesEn(response.data.contactTitles);
                }
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const getContactTitlesFr = async () => {
        let url = "https://api.whise.eu/v1/contacts/titles/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${reduxClientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let body = {
            LanguageId: "fr-BE"
        }

        axios.post(url, body, config)
            .then(response => {
                if (response.data.isValidRequest) {
                    setContactTitlesFr(response.data.contactTitles);
                }
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const getContactTitlesNl = async () => {
        let url = "https://api.whise.eu/v1/contacts/titles/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${reduxClientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let body = {
            LanguageId: "nl-BE"
        }

        axios.post(url, body, config)
            .then(response => {
                if (response.data.isValidRequest) {
                    setContactTitlesNl(response.data.contactTitles);
                }
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const handleConfirmWindowClose = () => {
        setShowConfirmationModel(false);
        setModalMessageLocalToWhiseSync("");
        setModalMessageWhiseToLocalSync("");
    }

    const callBackConfirmSyncOfFreeSlots = (selection, isCanceled) => {
        if (isCanceled == false) {
            setIsFreeSlotWhiseSyncEnabled(selection);
        }
        setShowConfirmationModel(false);
        setModalMessageLocalToWhiseSync("");
        setModalMessageWhiseToLocalSync("");
    }

    const handleChangeContactTitles = (selected) => {
        setSelectedTitles(selected);
    }

    // get offices list from local db using client default offfice id
    const getOfficesListFromlocalDB = async () => {
        try {
            let url = `${variables.API_URL}Settings/GetOfficeDetailsFromClientSetting?officeId=${officeId}`;

            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);

            if (response.data.response) {

                let _officesDetail = JSON.parse(response.data.response); // convert json
                setOfficeList(_officesDetail);

                // select client default office
                let _filteredOffice = _officesDetail.filter((item) => { return item.Id == officeId });
                if (_filteredOffice.length > 0) {
                    setOffice(_filteredOffice[0]);
                    setSelectOffice(_filteredOffice[0].Id);
                    getOfficesLogo(_filteredOffice[0].Id);
                } else {
                    getWhiseOffices();
                }

            } else {
                getWhiseOffices();
            }
        } catch (error) {
            console.log(error);
            getWhiseOffices();
        }
    }

    useEffect(() => {
        if (whiseUserToken) {
            getOfficeSettings();
            getOfficesListFromlocalDB();
        }
    }, [clientId, whiseUserToken])

    useEffect(() => {
        if (actions != null && actions != undefined) {
            setCalendarActions(actions);
        }
    }, [actions])

    useEffect(() => {
        if (reduxClientToken) {
            getAgents();
            getContactTitlesEn();
            getContactTitlesFr();
            getContactTitlesNl();
        }
    }, [reduxClientToken, savedContactTitles])

    useEffect(() => {

        if (reduxSelectedLanguage && contactTitles.length > 0) {
            let existingTitles = [...contactTitles];

            let titlesWithLanguageChange = existingTitles.map(item => {
                let description = "";
                if (reduxSelectedLanguage == "nl-BE") {
                    description = item.labelNl;
                }
                else if (reduxSelectedLanguage == "fr-BE") {
                    description = item.labelFr;
                }
                else {
                    description = item.labelEn;
                }

                return { ...item, label: description }
            })
            setContactTitles(titlesWithLanguageChange);

            if (selectedTitles.length > 0) {
                const selectedIds = selectedTitles.map(t => t.value);
                let filteredByLanguage = titlesWithLanguageChange.filter(title => {
                    return selectedIds.includes(title.value);
                })
                setSelectedTitles(filteredByLanguage);
            }
        }
    }, [reduxSelectedLanguage]);

    useEffect(() => {
        if (contactTitlesEn.length > 0 && contactTitlesFr.length > 0 && contactTitlesNl.length > 0) {

            let _contactTitlesInEng = [...contactTitlesEn];
            let _contactTitlesInFrench = [...contactTitlesFr];
            let _contactTitlesInDutch = [...contactTitlesNl];

            let _contactTitles = _contactTitlesInEng.map((item, i) => {
                let description = "";
                if (reduxSelectedLanguage == "nl-BE") {
                    description = _contactTitlesInDutch[i].shortDescription
                }
                else if (reduxSelectedLanguage == "fr-BE") {
                    description = _contactTitlesInFrench[i].shortDescription
                }
                else {
                    description = item.shortDescription
                }

                return { label: description, value: item.id, labelEn: item.shortDescription, labelFr: _contactTitlesInFrench[i].shortDescription, labelNl: _contactTitlesInDutch[i].shortDescription }
            })

            setContactTitles(_contactTitles);
            if (savedContactTitles != "" && savedContactTitles != null) {
                let filteredList = _contactTitles.filter(f => {
                    return savedContactTitles.indexOf(f.value) > -1
                })
                setSelectedTitles(filteredList);
            }
        }
    }, [contactTitlesEn, contactTitlesFr, contactTitlesNl])

    useEffect(() => {
        if (reduxSelectedLanguage) {
            getEstatePurposeStatusList(reduxSelectedLanguage);
        }
    }, [reduxSelectedLanguage]);

    const handleWaitingListModel = (event) => {
        setWaitingModalShow(true);
    }

    const handleWaitingAlertClose = () => {
        setWaitingModalShow(false);
    }

    const onChangeFreeSlotVisibilityForSaleEstate = (e) => {
        const value = e.target.value;
        setFreeSlotVisibilityForSaleEstate(value);
    }

    const onChangeFreeSlotVisibilityForRentEstate = (e) => {
        const value = e.target.value;
        setFreeSlotVisibilityForRentEstate(value);
    }

    const navigateAgencyTab = () => {
        setActiveTab("agency");
        scrollToElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }

    const handleBookEventsShowOnBookingSite = (event) => {
        setBookEventsShowOnBookingSite(event);
    }

    useEffect(() => {
        if (activeTab == "agency" && selectOffice != "") {
            //console.log(selectOffice);
            let payload = {
                clientId: clientId,
                estateId: "12345", // dumy estate id
                officeId: selectOffice,
                actionType: "ui",
                settingType: "office"
            }

            //const fetchEstateOfficeSetting = async () => {
            //    const getEstateAndOfficeSetting = await getEstateAndOfficeSettingAgentsite(payload);
            //    //console.log(officeSetting);

            //    // office not exist in the local db
            //    if (getEstateAndOfficeSetting.validationMessage.toLowerCase() == "client") {
            //        // automatic slot accept
            //        setAutomaticSlotSetupClientLevel(true);
            //        setIsAutomaticSlotAccept(officeSetting.automaticSlotAcceptation);

            //        // waiting list enabled
            //        setIsWaitingListSetupClientLevel(true);
            //        setIsWaitingListEnabled(officeSetting.waitingListEnabled);
            //        setOfficeLanguage("fr-BE");
            //        return;
            //    }

            //    // automatic slot accept
            //    if (getEstateAndOfficeSetting.automaticSlotAcceptation.toLowerCase() == "clientdefault") {
            //        setAutomaticSlotSetupClientLevel(true);
            //        setIsAutomaticSlotAccept(officeSetting.automaticSlotAcceptation);
            //    } else if (getEstateAndOfficeSetting.automaticSlotAcceptation.toLowerCase() == "true") {
            //        setIsAutomaticSlotAccept(true);
            //        setAutomaticSlotSetupClientLevel(false);
            //    } else {
            //        setIsAutomaticSlotAccept(false);
            //        setAutomaticSlotSetupClientLevel(false);
            //    }

            //    // waiting list
            //    if (getEstateAndOfficeSetting.waitingListEnabled.toLowerCase() == "clientdefault") {
            //        setIsWaitingListSetupClientLevel(true);
            //        setIsWaitingListEnabled(officeSetting.waitingListEnabled);
            //    } else if (getEstateAndOfficeSetting.waitingListEnabled.toLowerCase() == "true") {
            //        setIsWaitingListEnabled(true);
            //        setIsWaitingListSetupClientLevel(false);
            //    } else {
            //        setIsWaitingListEnabled(false);
            //        setIsWaitingListSetupClientLevel(false);
            //    }
            //    debugger
            //    //office language
            //    if (getEstateAndOfficeSetting.officeLanguage) {
            //        setOfficeLanguage(getEstateAndOfficeSetting.officeLanguage);
            //    } else {
            //        setOfficeLanguage("fr-BE");
            //    }
            //}
            const fetchEstateOfficeSetting = async () => {
                const getEstateAndOfficeSetting = await getEstateAndOfficeSettingAgentsite(payload);

                // office not exist in the local db
                if (getEstateAndOfficeSetting.validationMessage.toLowerCase() == "client") {
                    setAutomaticSlotSetupClientLevel(true);
                    setIsAutomaticSlotAccept(officeSetting.automaticSlotAcceptation);
                    setIsWaitingListSetupClientLevel(true);
                    setIsWaitingListEnabled(officeSetting.waitingListEnabled);

                    setOfficeLanguageSetupClientLevel(true);
                    const clientDefaultLang = await getClientDefaultLanguageFromWhise();
                    setOfficeLanguage(clientDefaultLang);
                    return;
                }

                // automatic slot accept
                if (getEstateAndOfficeSetting.automaticSlotAcceptation.toLowerCase() == "clientdefault") {
                    setAutomaticSlotSetupClientLevel(true);
                    setIsAutomaticSlotAccept(officeSetting.automaticSlotAcceptation);
                } else if (getEstateAndOfficeSetting.automaticSlotAcceptation.toLowerCase() == "true") {
                    setIsAutomaticSlotAccept(true);
                    setAutomaticSlotSetupClientLevel(false);
                } else {
                    setIsAutomaticSlotAccept(false);
                    setAutomaticSlotSetupClientLevel(false);
                }

                // waiting list
                if (getEstateAndOfficeSetting.waitingListEnabled.toLowerCase() == "clientdefault") {
                    setIsWaitingListSetupClientLevel(true);
                    setIsWaitingListEnabled(officeSetting.waitingListEnabled);
                } else if (getEstateAndOfficeSetting.waitingListEnabled.toLowerCase() == "true") {
                    setIsWaitingListEnabled(true);
                    setIsWaitingListSetupClientLevel(false);
                } else {
                    setIsWaitingListEnabled(false);
                    setIsWaitingListSetupClientLevel(false);
                }

                // office language
                if (getEstateAndOfficeSetting.officeLanguage && getEstateAndOfficeSetting.officeLanguage.toLowerCase() == "clientdefault") {
                    setOfficeLanguageSetupClientLevel(true);
                    const clientDefaultLang = await getClientDefaultLanguageFromWhise();
                    setOfficeLanguage(clientDefaultLang);
                } else if (getEstateAndOfficeSetting.officeLanguage) {
                    setOfficeLanguageSetupClientLevel(false);
                    setOfficeLanguage(getEstateAndOfficeSetting.officeLanguage);
                } else {
                    setOfficeLanguageSetupClientLevel(true);
                    const clientDefaultLang = await getClientDefaultLanguageFromWhise();
                    setOfficeLanguage(clientDefaultLang);
                }
            }

            fetchEstateOfficeSetting();

        } else if (whiseUserToken && activeTab == "client" && selectOffice != "") {
            getOfficeSettings();
        }
    }, [activeTab, selectOffice]);

    const saveEstateAndOfficeSetting = async () => {
        try {
            let url = `${variables.API_URL}Preferences/SaveEstateOrOfficeSetting`;

            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };
            let body = {
                "settingType": "office",
                "clientId": +clientId,
                "officeId": +selectOffice,
                "setting": {
                    "automaticSlotAcceptation": `${automaticSlotSetupClientLevel ? "clientDefault" : isAutomaticSlotAccept}`,
                    "waitingListEnabled": `${isWaitingListSetupClientLevel ? "clientDefault" : isWaitingListEnabled}`,
                    //  "officeLanguage": officeLanguage
                    "officeLanguage": `${officeLanguageSetupClientLevel ? "clientDefault" : officeLanguage}`

                }
            }

            if (officeSetting == null) {
                alert(reduxLanguageTranslations ? reduxLanguageTranslations["saveOfficeBeforeClient"] : "Please save the Office Settings before saving the Client Settings");
                setActiveTab("client");
                return;
            }

            const response = await axios.post(url, body, jsonconfig);

            if (response.data) {
                //console.log(response.data);
                showMessage("success", response.data);
                saveAndUpdateOfficeLog();

                let payloadOfficeList = {
                    officeId: officeId,
                    officeDetail: JSON.stringify(officeList),
                }

                saveOfficesListInLocalDB(payloadOfficeList);
            }
        } catch (error) {
            showMessage("error", "Api request failed");
            console.log(error);
        }
    }

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const getEstatePurposeStatusList = async (selectLanguage) => {
        try {
            let url = `${variables.API_URL}LocalEvents/GetPurposeStatusByEstate`;

            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };

            const response = await axios.get(url, config);
            if (response.data.data.length > 0) {

                const labelMap = { "fr-BE": "nameFr", "nl-BE": "nameNl" };
                const labelKey = labelMap[selectLanguage] || "nameEn";

                const purposeStatusLangSpecifice = response.data.data.map(({ id, nameEn, nameFr, nameNl }) => ({
                    value: id,
                    label: { nameEn, nameFr, nameNl }[labelKey],
                    labelEn: nameEn,
                    labelFr: nameFr,
                    labelNl: nameNl,
                }));

                setEstatePurposeStatusList(purposeStatusLangSpecifice);


                // Estate purpose status for "deactive"
                const labelKeySelected = { "fr-BE": "labelFr", "nl-BE": "labelNl" }[selectLanguage] || "labelEn";
                let defaultSelectDeactivePropertystatus = [3, 14, 4, 8, 9, 17];

                const selectedPurposeStatusLangSpecifice = selectDeactiveEstatePurposeStatus.length > 0
                    ? selectDeactiveEstatePurposeStatus.map(({ value, labelEn, labelFr, labelNl }) => ({
                        value,
                        label: { labelEn, labelFr, labelNl }[labelKeySelected],
                        labelEn,
                        labelFr,
                        labelNl,
                    }))
                    :
                    purposeStatusLangSpecifice.filter(item => defaultSelectDeactivePropertystatus.includes(item.value));

                setSelectDeactiveEstatePurposeStatus(selectedPurposeStatusLangSpecifice);


                // Estate purpose status for "on hold"
                const labelKeySelectedOnhold = { "fr-BE": "labelFr", "nl-BE": "labelNl" }[selectLanguage] || "labelEn";
                let defaultSelectOnHoldPropertystatus = [5, 6, 10, 11, 12, 13, 16, 21, 22];

                const selectedPurposeStatusByOnHoldLangSpec = selectEstatePurposeStatusListByOnHold.length > 0
                    ? selectEstatePurposeStatusListByOnHold.map(({ value, labelEn, labelFr, labelNl }) => ({
                        value,
                        label: { labelEn, labelFr, labelNl }[labelKeySelectedOnhold],
                        labelEn,
                        labelFr,
                        labelNl,
                    }))
                    :
                    purposeStatusLangSpecifice.filter(item => defaultSelectOnHoldPropertystatus.includes(item.value));;

                setSelectEstatePurposeStatusListByOnHold(selectedPurposeStatusByOnHoldLangSpec);

            }
        } catch (error) {
            console.log(error);
        }
    }

    const onChangeEstatePurposeStatusForDeactive = (event) => {
        setSelectDeactiveEstatePurposeStatus(event);
        setIsUniqueEstatePurposeConfigStatus(false);
        setDeactiveEstateConfigValid(false);
    }

    const onChangeEstatePurposeStatusByOnHold = (event) => {
        setSelectEstatePurposeStatusListByOnHold(event);
        setIsUniqueEstatePurposeConfigStatus(false);
        setOnHoldEstateConfigValid(false);
    }

    // On hold and deactive property status functionality
    const checkBoxPropertyStatusToSendEmail = (e) => {
        const value = e.target.checked;
        setIsManagePropertyStatusChangeCustomEmail(value);
        if (value == true) {
            setIsSelectSpecificEmailByPropertyStatus("");
            setIsCustomEmailByPropertyStatus("");
            setSelectAgentByPropertyStatus("");
        }
    }

    const handlerSelectSpecificEmailByPropertyStatus = (e) => {
        const value = e.target.value;
        setIsSelectSpecificEmailByPropertyStatus(value);
        if (value == 2) {
            setIsCustomEmailByPropertyStatus("");
        }
        setIsSelectSpecificEmailEmptyByPropertyStatus("");
    }

    const onChangePropertyStatusSelectAgent = (e) => {
        const value = e.target.value;
        setSelectAgentByPropertyStatus(value);
        setIsSelectAgentEmptyByPropertyStatus("");
    }

    const onChangePropertyStatusCustomEmail = (e) => {
        const value = e.target.value;
        setIsCustomEmailByPropertyStatus(value);
        setIsCustomEmailEmptyByPropertyStatus("");
    }

    const onChangeTimeDelayByPropertyStatus = (e) => {
        const value = e.target.value;
        setTimeDelayByPropertyStatus(value);
    }

    const onChangeCancelVisitCalanderActionId = (e) => {
        const value = e.target.value;
        setCancelVisitCalanderActionId(value);
    }

    const onChangeConfirmVisitBackupMethod = (e) => {
        const value = e.target.value;
        setConfirmedVisitBackupMethod(value);
    }

    // CRM Email Logging functionality
    const checkBoxCrmEmailLogging = (e) => {
        const value = e.target.checked;
        setEnableCustomCRMEmailLogging(value);
        if (value == true) {
            setAgentIdCRMEmailLogging("");
            setSelectCRMEmailLoggingOption("1");
            setIsEmptyCrmEmailLoggingField("");
        }
    }

    const onChangeSelectCrmEmailLoggingOption = (e) => {
        const value = e.target.value;
        setSelectCRMEmailLoggingOption(value);
        setAgentIdCRMEmailLogging("");
        setIsEmptyCrmEmailLoggingField("");
    }

    const onChangeAgentIdSelectCrmEmailLogging = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setAgentIdCRMEmailLogging(value);
            setIsEmptyCrmEmailLoggingField("");
        }
        //setAgentIdCRMEmailLogging(value);
        //setIsEmptyCrmEmailLoggingField("");
    }

    const onChangeToggleCrmEmailLogging = (e) => {
        setIsEnableCrmEmailLogging(e);
        setEnableCustomCRMEmailLogging(false);
        setAgentIdCRMEmailLogging("");
        setSelectCRMEmailLoggingOption("1");
        setIsEmptyCrmEmailLoggingField("");
    }

    return (
        <div className="setting-container px-4 mx-4 pt-4">
            <div className="row mb-4">
                <div className="col-6">
                    <ul className="nav nav-tabs border-0">
                        <li className="nav-item">
                            <button
                                className={`nav-link setting-tab-btn ${activeTab === "client" ? "active custom-active" : ""}`}
                                onClick={() => setActiveTab("client")}
                            >
                                {reduxLanguageTranslations ? reduxLanguageTranslations["clientSetting"] : "Client setting"}
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link setting-tab-btn ${activeTab === "agency" ? "active custom-active" : ""}`}
                                onClick={() => setActiveTab("agency")}
                            >
                                {reduxLanguageTranslations ? reduxLanguageTranslations["agencySetting"] : "Agency setting"}
                            </button>
                        </li>
                    </ul>
                </div>
                <div className="col-6">
                </div>
            </div>
            <div className={`${activeTab == "agency" ? "row mb-5" : "d-none"}`}>
                <div className="col-12">
                    <span className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageAgencyDetailsLbl"] : "Agency Details"}</span>
                    <div className="form-container mt-1">
                        <div className="form-group row align-items-center pt-2">
                            <label htmlFor="officeName" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageOfficeLbl"] : "Office"}</label>
                            <div className="col-sm-12">
                                <select className={`form-select`} id="officeList" value={selectOffice} onChange={handlerSelectOffice}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageSelectOfficeOption"] : "Select Office"}</option>
                                    {
                                        officeList.length > 0 ? officeList.map((item, index) => {
                                            return (
                                                <option value={item.id || item.Id} key={index}>{item.name || item.Name}</option>
                                            )
                                        }) :
                                            <></>
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <div className="col-6">
                                <label htmlFor="officeName" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageOfficeNameLbl"] : "Office Name"}</label>
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" id="officeName" defaultValue={office.name || office.Name} />
                                </div>
                            </div>
                            <div className="col-6">
                                <label htmlFor="officeId" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageOfficeIdLbl"] : "Office ID"}</label>
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" id="officeId" defaultValue={office.id || office.Id} />
                                </div>
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <div className="col-4">
                                <label htmlFor="street" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageStreetLbl"] : "Street"}</label>
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" id="street" defaultValue={office.address1 || office.Address1} />
                                </div>
                            </div>
                            <div className="col-4">
                                <label htmlFor="number" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNumberLbl"] : "Number"}</label>
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" id="number" defaultValue={office.number || office.Number} />
                                </div>
                            </div>
                            <div className="col-4">
                                <label htmlFor="box" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageBoxLbl"] : "Box"}</label>
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" id="box" defaultValue={office.box || office.Box} />
                                </div>
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <div className="col-4">
                                <label htmlFor="zip" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageZipLbl"] : "Zip"}</label>
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" id="zip" defaultValue={office.zip || office.Zip} />
                                </div>
                            </div>
                            <div className="col-4">
                                <label htmlFor="city" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageCityLbl"] : "City"}</label>
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" id="city" defaultValue={office.city || office.City} />
                                </div>
                            </div>
                            <div className="col-4">
                                <label htmlFor="country" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageCountryLbl"] : "Country"}</label>
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" id="country" defaultValue={office.countryId || office.CountryId} />
                                </div>
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <div className="col-6">
                                <label htmlFor="officeTel" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageOfficeTelLbl"] : "Office tel"}</label>
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" id="officeTel" defaultValue={office.telephone || office.Telephone} />
                                </div>
                            </div>
                            <div className="col-6">
                                <label htmlFor="officeMobile" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageOfficeMobileLbl"] : "Office mobile number"}</label>
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" id="officeMobile" defaultValue={office.mobile || office.Mobile} />
                                </div>
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <div className="col-6">
                                <label htmlFor="officeEmail" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageOfficeEmailsLbl"] : "Office Emails"}</label>
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" id="officeEmail" defaultValue={office.email || office.Email} />
                                </div>
                            </div>
                            <div className="col-6">
                                <label htmlFor="officeWebsite" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageOfficeWebsiteLbl"] : "Office Website"}</label>
                                <div className="col-sm-12">
                                    <input type="text" className="form-control" id="officeWebsite" defaultValue={office.website || office.Website} />
                                </div>
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <label htmlFor="urlLink" className="col-sm-12 form-group-label mt-0 mb-2 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageUrllinkLbl"] : "Or URL link"}</label>
                            <div className="col-sm-6">
                                <input type="text" className="form-control" id="urlLink" defaultValue={clientSettings != null && clientSettings.logoUrl != undefined ? clientSettings.logoUrl : ""} readOnly />
                            </div>
                            {
                                file != null ?
                                    <div className="col-sm-1">
                                        <img src={file != null ? file : ""} className="mw-100" style={{ maxHeight: "52px" }} />
                                    </div>
                                    :
                                    <></>
                            }
                            {/*<div className="col-sm-4">*/}
                            {/*    <input type="file" className="form-control d-none" id="uploadOfficeLogo" onChange={handlerChangeUploadOfficeLogo} />*/}
                            {/*    <div className="d-flex algin-items-center">*/}
                            {/*        <button className="site-btn-red site-btn-padd" onClick={navigateAgencyTab}>{reduxLanguageTranslations ? reduxLanguageTranslations["viewDetail"] : "View detail"} <img src={rightArrowWhite} alt="right arrow" /></button>*/}
                            {/*        <p className="mb-0">choose the file</p>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="col-sm-5">
                                <div className="d-flex align-items-center">
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        id="uploadOfficeLogo"
                                        onChange={handlerChangeUploadOfficeLogo}
                                        style={{ display: "none" }}
                                    />
                                    <button
                                        type="button"
                                        className="btn fs-fourteen d-flex align-items-center gap-2 text-white"
                                        onClick={handleClick}
                                        style={{ background: "#1E2939" }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                            <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                                        </svg>
                                        {reduxLanguageTranslations ? reduxLanguageTranslations["chooseFile"] : "Choose a file"}
                                    </button>
                                    {
                                        fileName != "" ?
                                            <small className="text-muted d-block ms-2 fs-fourteen">{fileName}</small>
                                            :
                                            <small className="text-muted d-block ms-2 fs-fourteen">{reduxLanguageTranslations ? reduxLanguageTranslations["noFileChosen"] : "No file chosen"}</small>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`row ${activeTab === "client" ? "" : "d-none"}`}>
                <div className="col-12">
                    <span className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageCalendarSettingsLbl"] : "Calendar Settings"}<span className="text-danger login-field-error ms-2">{validationMessage}</span></span>
                    <div className="setting-calendarActions-container mt-3 mb-4">
                        <div className="row calendar-action-dropdowns-container">
                            <div className="col-sm-3">
                                <span className="form-heading">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSmartCalLabelsText"] : "SmartCal labels"}</span>
                            </div>
                            <div className="col-sm-3">
                                <span className="form-heading">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageFreeSlotLbl"] : "Free Slot"}</span>
                            </div>
                            <div className="col-sm-3">
                                <span className="form-heading">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageBeforeConfirmationLbl"] : "Before Confirmation"}</span>
                            </div>
                            <div className="col-sm-3">
                                <span className="form-heading">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageAfterConfirmationLbl"] : "After Confirmation"}</span>
                            </div>
                        </div>
                        <div className="sale-calendarAction row py-3 d-flex align-items-center">
                            <div className="col-3">
                                <span className="form-label">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageVisitToSaleLbl"] : "Visit (to Sale)"}</span>
                            </div>
                            <div className="col-3">
                                <select className={`form-select ${isSaleVisitFreeSlotEmpty}`} id="visitToSaleFreeSlot" value={saleVisitFreeSlot}
                                    onChange={handlerVisitToSaleFreeSlot}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>
                            <div className="col-3">
                                <select className={`form-select ${isSaleVisitBeforeEmpty}`} id="visitToSaleBefore" value={saleVisitBefore}
                                    onChange={handlerVisitToSaleBefore}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>
                            <div className="col-3">
                                <select className={`form-select ${isSaleVisitAfterEmpty}`} id="visitToSaleAfter" value={saleVisitAfter}
                                    onChange={handlerVisitToSaleAfter}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="row py-3">
                            <div className="col-sm-3 d-flex align-items-center">
                                <span className="form-label">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageVisitToRentLbl"] : "Visit (to Rent)"}</span>
                            </div>
                            <div className="col-sm-3">
                                <select className={`form-select ${isRentVisitFreeSlotEmpty}`} id="visitToRentFreeSlot" value={rentVisitFreeSlot}
                                    onChange={handlerVisitToRentFreeSlot}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>
                            <div className="col-sm-3">
                                <select className={`form-select ${isRentVisitBeforeEmpty}`} id="visitToRentBefore" value={rentVisitBefore}
                                    onChange={handlerVisitToRentBefore}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>
                            <div className="col-sm-3">
                                <select className={`form-select ${isRentVisitAfterEmpty}`} id="visitToRentAfter" value={rentVisitAfter}
                                    onChange={handlerVisitToRentAfter}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*remove this "form-container" class for design update according to figma*/}

            <div className={`row ${activeTab === "client" ? "" : "d-none"}`}>
                <div className="col-12">
                    <span className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageEmailLbl"] : "Emails"}</span>
                    <div className="mt-3 mb-4">
                        <div className="form-group row align-items-center">
                            <div className="col-sm-12 col-md-9">
                                <label htmlFor="officeName" className="form-group-label me-2 my-0">
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageDeactivateEmailLbl"] : "Deactivate the 'accepted visit confirmation' email"}
                                </label>
                            </div>
                            <div className="col-sm-12 col-md-3 d-flex">
                                <label className="modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 me-2" htmlFor={`radioradioYes`}>
                                    <input className="custom-radio me-2" type="radio" name={`radioDisableAcceptEmail`} id={`radioYes`} checked={isAcceptenceEmailDisabled === true} onChange={(e) => setIsAcceptenceEmailDisabled(previous => !previous)} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}
                                </label>
                                <label className="modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0" htmlFor={`radioNo`}>
                                    <input className="custom-radio me-2" type="radio" name={`radioDisableAcceptEmail`} id={`radioNo`} checked={isAcceptenceEmailDisabled === false} onChange={(e) => setIsAcceptenceEmailDisabled(previous => !previous)} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center">
                        <p className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["autoAcceptEmailLbl"] : "Automatic Acceptation"}</p>
                        <div className={`${activeTab == "client" ? "d-none" : "d-flex"}`}>
                            <div className="d-flex align-items-center me-3">
                                <input className="custom-radio me-2" type="radio" name={`automaticClientDefault`} id={`automaticClientDefault`} checked={automaticSlotSetupClientLevel == true} onChange={(e) => setAutomaticSlotSetupClientLevel(previous => !previous)} />
                                <p className="mb-0 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["setupClientLevel"] : "Setup client level"}</p>
                            </div>
                            <div className="d-flex align-items-center">
                                <input className="custom-radio me-2" type="radio" name={`automaticClientDefault`} id={`automaticOfficeDefault`} checked={automaticSlotSetupClientLevel == false} onChange={(e) => setAutomaticSlotSetupClientLevel(previous => !previous)} />
                                <p className="mb-0 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["setupOfficeLevel"] : "Setup office level"}</p>
                            </div>
                        </div>
                    </div>
                    <div className="mt-3 mb-4">
                        <div className="form-group row align-items-center">
                            <div className="col-sm-12 col-md-9">
                                <label htmlFor="officeName" className="form-group-label me-2 my-0">
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["autoAcceptEmailHeading"] : "Automatic slot acceptation with email"}
                                </label>
                            </div>
                            <div className="col-sm-12 col-md-3 d-flex">
                                <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 me-2 ${activeTab != "client" && automaticSlotSetupClientLevel ? "opacity-50" : ""}`} htmlFor={`radioYesBtn`}>
                                    <input className="custom-radio me-2" type="radio" name={`radioAutomaticSlotAccept`} id={`radioYesBtn`} disabled={activeTab === "client" ? false : automaticSlotSetupClientLevel} checked={isAutomaticSlotAccept == true} onChange={(e) => setIsAutomaticSlotAccept(previous => !previous)} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}
                                </label>
                                <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 ${activeTab != "client" && automaticSlotSetupClientLevel ? "opacity-50" : ""}`} htmlFor={`radioNoBtn`}>
                                    <input className="custom-radio me-2" type="radio" name={`radioAutomaticSlotAccept`} id={`radioNoBtn`} disabled={activeTab === "client" ? false : automaticSlotSetupClientLevel} checked={isAutomaticSlotAccept == false} onChange={(e) => setIsAutomaticSlotAccept(previous => !previous)} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center">
                        <p className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["waitingListHeading"] : "Waiting list"}</p>
                        <div className={`${activeTab == "client" ? "d-none" : "d-flex"}`}>
                            <div className="d-flex align-items-center me-3">
                                <input className="custom-radio me-2" type="radio" name={`waitingListRadioBtn`} id={`waitingListClientDefault`} checked={isWaitingListSetupClientLevel == true} onChange={(e) => setIsWaitingListSetupClientLevel(previous => !previous)} />
                                <p className="mb-0 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["setupClientLevel"] : "Setup client level"}</p>
                            </div>
                            <div className="d-flex align-items-center">
                                <input className="custom-radio me-2" type="radio" name={`waitingListRadioBtn`} id={`waitingListOfficeDefault`} checked={isWaitingListSetupClientLevel == false} onChange={(e) => setIsWaitingListSetupClientLevel(previous => !previous)} />
                                <p className="mb-0 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["setupOfficeLevel"] : "Setup office level"}</p>
                            </div>
                        </div>
                    </div>
                    <div className="mt-1 mb-4">
                        <div className="form-group row align-items-center">
                            <div className="col-sm-12 col-md-9">
                                <label htmlFor="officeName" className="form-group-label me-2 my-0">
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["waitingListEnabledSubHeading"] : "Waiting list Enabled"}
                                </label>
                            </div>
                            <div className="col-sm-12 col-md-3 d-flex">
                                <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 me-2 ${activeTab != "client" && isWaitingListSetupClientLevel ? "opacity-50" : ""}`} htmlFor={`radioYesBtnWaitingList`}>
                                    <input className="custom-radio me-2" type="radio" name={`radioWaitingListEnabled`} id={`radioYesBtnWaitingList`} disabled={activeTab === "client" ? false : isWaitingListSetupClientLevel} checked={isWaitingListEnabled === true} onChange={() => handleWaitingListModel(true)} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}
                                </label>
                                <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 ${activeTab != "client" && isWaitingListSetupClientLevel ? "opacity-50" : ""}`} htmlFor={`radioNoBtnWaitingList`}>
                                    <input className="custom-radio me-2" type="radio" name={`radioWaitingListEnabled`} id={`radioNoBtnWaitingList`} disabled={activeTab === "client" ? false : isWaitingListSetupClientLevel} checked={isWaitingListEnabled === false} onChange={() => handleWaitingListModel(false)} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}
                                </label>
                            </div>
                        </div>
                    </div>
                    {/*<div className={`row ${activeTab === "agency" ? "" : "d-none"}`}>*/}
                    {/*    <div className="col-12">*/}
                    {/*        <p className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["officeLanguage"] : "Office Language"}</p>*/}
                    {/*        <div className="mt-3 mb-4">*/}
                    {/*            <div className="form-group row align-items-center">*/}
                    {/*                <div className="col-sm-12 col-md-9">*/}
                    {/*                    <label htmlFor="officeLanguage" className="form-group-label me-2 my-0">*/}
                    {/*                        {reduxLanguageTranslations ? reduxLanguageTranslations["officeLanguageHeading"] : "Default language for this office"}*/}
                    {/*                    </label>*/}
                    {/*                </div>*/}
                    {/*                <div className="col-sm-12 col-md-3">*/}
                    {/*                    <select className="form-select" id="officeLanguage" value={officeLanguage} onChange={onChangeOfficeLanguage}>*/}
                    {/*                        <option value="fr-BE">French (fr-BE)</option>*/}
                    {/*                        <option value="en-GB">English (en-GB)</option>*/}
                    {/*                        <option value="nl-BE">Dutch (nl-BE)</option>*/}
                    {/*                    </select>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className={`row ${activeTab === "agency" ? "" : "d-none"}`}>
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-center">
                                <p className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["officeLanguage"] : "Office Language"}</p>
                                <div className="d-flex">
                                    <div className="d-flex align-items-center me-3">
                                        <input className="custom-radio me-2" type="radio" name={`officeLanguageClientDefault`} id={`officeLanguageClientDefault`} checked={officeLanguageSetupClientLevel == true} onChange={(e) => setOfficeLanguageSetupClientLevel(previous => !previous)} />
                                        <p className="mb-0 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["setupClientLevel"] : "Setup client level"}</p>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <input className="custom-radio me-2" type="radio" name={`officeLanguageClientDefault`} id={`officeLanguageOfficeDefault`} checked={officeLanguageSetupClientLevel == false} onChange={(e) => setOfficeLanguageSetupClientLevel(previous => !previous)} />
                                        <p className="mb-0 fw-bold">{reduxLanguageTranslations ? reduxLanguageTranslations["setupOfficeLevel"] : "Setup office level"}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 mb-4">
                                <div className="form-group row align-items-center">
                                    <div className="col-sm-12 col-md-9">
                                        <label htmlFor="officeLanguage" className="form-group-label me-2 my-0">
                                            {reduxLanguageTranslations ? reduxLanguageTranslations["officeLanguageHeading"] : "Enable office specific language"}
                                        </label>
                                    </div>
                                    <div className={`col-sm-12 col-md-3 ${officeLanguageSetupClientLevel ? "opacity-50" : ""}`}>
                                        <select className="form-select" id="officeLanguage" value={officeLanguage} onChange={onChangeOfficeLanguage} disabled={officeLanguageSetupClientLevel}>
                                            <option value="fr-BE">French (fr-BE)</option>
                                            <option value="en-GB">English (en-GB)</option>
                                            <option value="nl-BE">Dutch (nl-BE)</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`row ${activeTab === "client" ? "" : "d-none"}`}>
                <div className="col-12">
                    <span className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["manageFreeSlotVisibility"] : "Manage Free Slot Visibility"}</span>
                    <div className="mt-3 mb-4">
                        <div className="form-group row align-items-center">
                            <div className="col-sm-12 col-md-12">
                                <div className="row">
                                    <div className="col-sm-12 col-md-3">
                                        <p className="form-heading mb-4">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusRent"] : "For rent"}</p>
                                        <select className={`form-select`} id="freeSlotVisibilityForRent" value={freeSlotVisibilityForRentEstate} onChange={onChangeFreeSlotVisibilityForRentEstate}>
                                            <option value="null">{reduxLanguageTranslations ? reduxLanguageTranslations["displayModeDefault"] : "Display All Available slots"}</option>
                                            <option value="DISPLAY_BLOCK_FIRST">{reduxLanguageTranslations ? reduxLanguageTranslations["displayFirstOfBlock"] : "Display Only First Slot in Block"}</option>
                                            <option value="DISPLAY_BLOCK_MIDDLE">{reduxLanguageTranslations ? reduxLanguageTranslations["displayMiddleOfBlock"] : "Display Only Middle Slot in Block"}</option>
                                            <option value="DISPLAY_FIRST_BOOKER_ALL">{reduxLanguageTranslations ? reduxLanguageTranslations["displayAllForFirstGuy"] : "Display All Slots (First Booker Only)"}</option>
                                        </select>
                                    </div>
                                    <div className="col-sm-12 col-md-3">
                                        <p className="form-heading mb-4">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListFilterStatusSale"] : "For sale"}</p>
                                        <select className={`form-select`} id="freeSlotVisibilityForSale" value={freeSlotVisibilityForSaleEstate} onChange={onChangeFreeSlotVisibilityForSaleEstate}>
                                            <option value="null">{reduxLanguageTranslations ? reduxLanguageTranslations["displayModeDefault"] : "Display All Available slots"}</option>
                                            <option value="DISPLAY_BLOCK_FIRST">{reduxLanguageTranslations ? reduxLanguageTranslations["displayFirstOfBlock"] : "Display Only First Slot in Block"}</option>
                                            <option value="DISPLAY_BLOCK_MIDDLE">{reduxLanguageTranslations ? reduxLanguageTranslations["displayMiddleOfBlock"] : "Display Only Middle Slot in Block"}</option>
                                            <option value="DISPLAY_FIRST_BOOKER_ALL">{reduxLanguageTranslations ? reduxLanguageTranslations["displayAllForFirstGuy"] : "Display All Slots (First Booker Only)"}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Confirm and TBC events show on booking site */}
            <div className={`${activeTab === "client" ? "" : "d-none"} mt-1 mb-4`}>
                <div className="form-group row align-items-center">
                    <h2 className="form-title mb-3">{reduxLanguageTranslations ? reduxLanguageTranslations["displayBookedAppointmentsOnBookingPage"] : "Display Booked Appointments on Booking Page"}</h2>
                    <div className="col-sm-12 col-md-9">
                        <label htmlFor="officeName" className="form-group-label me-2 my-0">
                            {reduxLanguageTranslations ? reduxLanguageTranslations["displayTBCAndConfirmedSlotsInGrey"] : "When enabled, TBC and Confirmed slots are displayed in grey as non-selectable on the booking page"}
                        </label>
                    </div>
                    <div className="col-sm-12 col-md-3 d-flex">
                        <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 me-2`} htmlFor={`radioYesBtnBookEvents`}>
                            <input className="custom-radio me-2" type="radio" name={`radioBookEventsEnabled`} id={`radioYesBtnBookEvents`} checked={bookEventsShowOnBookingSite === true} onChange={() => handleBookEventsShowOnBookingSite(true)} />
                            {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}
                        </label>
                        <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0`} htmlFor={`radioNoBtnBookEvents`}>
                            <input className="custom-radio me-2" type="radio" name={`radioBookEventsEnabled`} id={`radioNoBtnBookEvents`} checked={bookEventsShowOnBookingSite === false} onChange={() => handleBookEventsShowOnBookingSite(false)} />
                            {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}
                        </label>
                    </div>
                </div>
            </div>

            <div className={`row ${activeTab === "client" ? "" : "d-none"}`}>
                <div className="col-12">
                    <span className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["setttingPageConfigurationHeading"] : "Configurations"}</span><span className="text-danger login-field-error ms-2">{validationMessageEnableCustomEmail}</span>
                    <div className="mt-3 mb-4">
                        <div className="form-group row align-items-center">
                            <div className="col-sm-12 col-md-12 d-flex">
                                <label className={`modal-p-text-black d-flex align-items-center`} htmlFor="checkboxSynchronization">
                                    <input className="form-check-input checkbox-green me-2 mt-0" type="checkbox" checked={isFreeSlotWhiseSyncEnabled} id="checkboxSynchronization" onChange={(e) => changeHandlerFreeSlotWhiseSynchronization(e)} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["setttingPageEnableFreeSlot"] : "Enable Free Slots Synchronization on Whise"}
                                </label>
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <div className="col-sm-4 col-md-4">
                                <label className={`modal-p-text-black d-flex align-items-center`} htmlFor="checkboxManageVisitReqCustomEmail">
                                    <input className="form-check-input checkbox-green me-2 mt-0" type="checkbox" checked={isManageVisitReqCustomEmail} id="checkboxManageVisitReqCustomEmail" onChange={handlerEnableVisitReqCheckbox} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingPageEnableVisitReq"] : "Enable management of visit request by:"}
                                </label>
                            </div>
                            <div className={`col-sm-3 col-md-3 ${isManageVisitReqCustomEmail ? "d-block" : "d-none"}`}>
                                <select className={`form-select ${isSelectSpecificEmailEmpty}`} id="selectCustomEmail" value={isSelectSpecificEmail} onChange={handlerSelectSpecificEmail}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageSelectOpt"] : "Select option"}</option>
                                    <option value="1">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageEstateOfficeEmailOpt"] : "Estate office email"}</option>
                                    <option value="2">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageOtherOpt"] : "Other"}</option>
                                </select>
                            </div>
                            <div className={`col-sm-5 col-md-5 ${isManageVisitReqCustomEmail && isSelectSpecificEmail == 2 ? "d-block" : "d-none"}`}>
                                <input className={`form-control ${isCustomEmailEmpty}`} value={isCustomEmail} onChange={handlerCustomEmail} />
                            </div>
                        </div>

                        <div className={`form-group row align-items-center pt-4 ${isManageVisitReqCustomEmail ? "d-flex" : "d-none"}`}>
                            <label htmlFor="officeName" className="col-sm-3 form-group-label my-0 justify-content-end">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageExceptionsLbl"] : "Exceptions:"}</label>
                            <div className="col-sm-1 col-md-1"></div>
                            <div className="col-sm-3 col-md-3">
                                <select className={`form-select ${isSelectAgentEmpty}`} id="agentList" value={selectAgent} onChange={handlerSelectAgent}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownAgentSelect"] : "Select Agent"}</option>
                                    {
                                        whiseAgents.length > 0 ? whiseAgents.map((item, i) => {
                                            return (
                                                <option value={item.id} data-agent={JSON.stringify(item)} key={i}>{item.firstName + " " + item.name}</option>
                                            )
                                        })
                                            :
                                            <></>
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*Notification when property is switched to pending*/}
            <div className={`mb-4 ${activeTab === "client" ? "" : "d-none"}`}>
                <div className="form-group row align-items-center pt-4">
                    <div className="col-sm-5 col-md-5">
                        <p className="mb-0 modal-p-text-black">
                            {reduxLanguageTranslations ? reduxLanguageTranslations["pendingStatusNotificationSetting"] : "Notification when property is switched to pending :"}
                            <span className="text-danger login-field-error ms-2">{validationMessagePendingNotification}</span>
                        </p>
                    </div>
                    <div className="col-sm-3 col-md-3">
                        <select className="form-select" id="pendingRecipientOption"
                            value={pendingRecipientOption} onChange={handlerPendingRecipientOption}>
                            <option value="1">{reduxLanguageTranslations ? reduxLanguageTranslations["pendingSameAsVisitRequestSetting"] : "Same as visit request setting"}</option>
                            <option value="2">{reduxLanguageTranslations ? reduxLanguageTranslations["pendingCustomOpt"] : "Custom"}</option>
                        </select>
                    </div>
                    <div className={`col-sm-3 col-md-3 ${pendingRecipientOption == 2 ? "d-block" : "d-none"}`}>
                        <select className={`form-select ${pendingCustomTypeEmptyClass}`} id="pendingCustomRecipientType"
                            value={pendingCustomRecipientType} onChange={handlerPendingCustomRecipientType}>
                            <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageSelectOpt"] : "Select option"}</option>
                            <option value="1">{reduxLanguageTranslations ? reduxLanguageTranslations["pendingEstateRepresentativeOpt"] : "Estate representative"}</option>
                            <option value="2">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageEstateOfficeEmailOpt"] : "Estate office email"}</option>
                            <option value="3">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageOtherOpt"] : "Other"}</option>
                        </select>
                    </div>
                </div>

                <div className={`form-group row align-items-center pt-3 ${pendingRecipientOption == 2 && pendingCustomRecipientType == 3 ? "d-flex" : "d-none"}`}>
                    <div className="col-sm-5 col-md-5 text-end">
                        <p className="mb-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageExceptionsLbl"] : "Exceptions:"}</p>
                    </div>
                    <div className="col-sm-3 col-md-3">
                        <select className={`form-select ${pendingAgentEmptyClass}`} id="pendingExceptionAgent"
                            value={pendingExceptionAgentId} onChange={onChangePendingExceptionAgent}>
                            <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownAgentSelect"] : "Select agent"}</option>
                            {
                                whiseAgents.length > 0 ? whiseAgents.map((item, i) => {
                                    return (
                                        <option value={item.id} data-agent={JSON.stringify(item)} key={i}>{item.firstName + " " + item.name}</option>
                                    )
                                })
                                    :
                                    <></>
                            }
                        </select>
                    </div>
                    <div className={`col-sm-3 col-md-3`}>
                        <input type="email" className={`form-control ${pendingEmailEmptyClass}`}
                            value={pendingExceptionAgentEmail} onChange={onChangePendingExceptionEmail} />
                    </div>
                </div>
            </div>
            <div className={`row ${activeTab === "client" ? "" : "d-none"}`}>
                <div className="col-12">
                    <span className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageHeadingBookingPageSettings"] : "Booking page Settings"}</span>
                    <div className="mt-3 mb-4">
                        <label htmlFor="officeName" className="col-sm-4 form-group-label mt-0 mb-1">{reduxLanguageTranslations ? reduxLanguageTranslations["labelMappingContactTitlesSettingsPage"] : "Mapping of Contact Titles"}</label>
                        <div className={`col-sm-5${selectedTitles.length > 0 ? " mb-2" : ""}`}>
                            <MultiSelect
                                id="contactTitles"
                                value={selectedTitles.length > 0 ? selectedTitles : []}
                                options={contactTitles}
                                onChange={handleChangeContactTitles}
                                labelledBy="Select contact titles"
                                overrideStrings={{
                                    search: reduxLanguageTranslations ? reduxLanguageTranslations["searchPlaceholderForMultiSelect"] : "Search",
                                    selectAll: reduxLanguageTranslations ? reduxLanguageTranslations["reactMultiSelectSelectAllLabel"] : "Select All"
                                }}
                            />
                        </div>
                        <div className="">
                            {
                                selectedTitles.length > 0 ? selectedTitles.map(title => {
                                    return (
                                        <div className={`text-danger`}>{title.label} (ID {title.value})</div>
                                    )
                                })
                                    :
                                    <></>
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/*CRM Email Logging */}
            <div className={`row mt-2 mb-4 ${activeTab === "client" && userAccountType == variables.UserAccountTypeIdentity ? "" : "d-none"}`}>
                <h2 className="form-title me-2 mb-4">{reduxLanguageTranslations ? reduxLanguageTranslations["whiseCrmEmailLogging"] : "Whise CRM email logging"}</h2>
                <div className="col-12">
                    <div className="d-flex align-items-center mb-1">
                        <h2 className="form-title me-2">{reduxLanguageTranslations ? reduxLanguageTranslations["enableContactEmailLoggingWhiseCrm"] : "Enable contact email logging in Whise CRM"}</h2>
                        <div

                            onClick={() => onChangeToggleCrmEmailLogging(!isEnableCrmEmailLogging)}
                            style={{
                                width: "50px",
                                height: "23px",
                                borderRadius: "999px",
                                backgroundColor: isEnableCrmEmailLogging ? "#27A376" : "#ccc",
                                position: "relative",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                            }}
                        >
                            <div
                                style={{
                                    width: "15px",
                                    height: "15px",
                                    borderRadius: "50%",
                                    backgroundColor: "white",
                                    position: "absolute",
                                    top: "4px",
                                    left: isEnableCrmEmailLogging ? "30px" : "4px",
                                    transition: "left 0.3s cubic-bezier(.34,1.56,.64,1)",
                                }}
                            />
                        </div>

                        {/*Label */}
                        {isEnableCrmEmailLogging && (

                            <LabelUI
                                label={reduxLanguageTranslations ? reduxLanguageTranslations["agentForLoggingSystemTriggeredEmails"] : "Active"}
                                content={reduxLanguageTranslations ? reduxLanguageTranslations["emailLoggingEnabledWhiseCrm"] : "Email logging is enabled. Emails will be logged to Whise CRM."}
                            />
                        )}
                    </div>
                </div>

                <div className={`form-group row align-items-center pt-4 mb-4 ${isEnableCrmEmailLogging ? "" : "d-none"}`}>
                    <div className={`col-sm-4 col-md-4 ${isEnableCrmEmailLogging ? "d-block" : "d-none"}`}>
                        <p className="mb-0">{reduxLanguageTranslations ? reduxLanguageTranslations["agentForLoggingSystemTriggeredEmails"] : "Active"}</p>
                    </div>
                    <div className={`col-sm-3 col-md-3 ${isEnableCrmEmailLogging ? "d-block" : "d-none"}`}>
                        <select className={`form-select`} id="selectCustomEmail" value={selectCRMEmailLoggingOption} onChange={onChangeSelectCrmEmailLoggingOption}>
                            <option value="1">{reduxLanguageTranslations ? reduxLanguageTranslations["estateRepresentative"] : "Estate representative"}</option>
                            <option value="2">{reduxLanguageTranslations ? reduxLanguageTranslations["specificUserAgentId"] : "Specific user / agent ID"}</option>
                            <option value="3">{reduxLanguageTranslations ? reduxLanguageTranslations["agentFromOfficeList"] : "Agent from office list"}</option>
                        </select>
                    </div>
                    <div className={`col-sm-3 col-md-3 ${isEnableCrmEmailLogging ? "d-block" : "d-none"}`}>
                        {
                            selectCRMEmailLoggingOption == 2 ?
                                //<input className={`form-control ${isEmptyCrmEmailLoggingField}`} value={agentIdCRMEmailLogging} onChange={onChangeAgentIdSelectCrmEmailLogging} onKeyDown={(e) => {
                                //    if (!/[0-9]/.test(e.key) && !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)) {
                                //        e.preventDefault();
                                //    }
                                //}}
                                //    inputMode="numeric"
                                ///>
                                <input
                                    className={`form-control ${isEmptyCrmEmailLoggingField}`}
                                    value={agentIdCRMEmailLogging}
                                    onChange={onChangeAgentIdSelectCrmEmailLogging}
                                    onKeyDown={(e) => {
                                        if (
                                            !/[0-9]/.test(e.key) &&
                                            !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "v"].includes(e.key) &&
                                            !e.ctrlKey &&
                                            !e.metaKey
                                        ) {
                                            e.preventDefault();
                                        }
                                    }}
                                    onPaste={(e) => {
                                        e.preventDefault();
                                        const pastedText = e.clipboardData.getData("text");
                                        const numericOnly = pastedText.replace(/[^0-9]/g, "");
                                        if (numericOnly) {
                                            // Create a synthetic event to work with your existing onChange handler
                                            const syntheticEvent = {
                                                target: {
                                                    value: numericOnly,
                                                },
                                            };
                                            onChangeAgentIdSelectCrmEmailLogging(syntheticEvent);
                                        }
                                    }}
                                    inputMode="numeric"
                                />
                                : selectCRMEmailLoggingOption == 3 ?
                                    <select className={`form-select ${isEmptyCrmEmailLoggingField}`} id="agentList" value={agentIdCRMEmailLogging} onChange={onChangeAgentIdSelectCrmEmailLogging}>
                                        <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownAgentSelect"] : "Select Agent"}</option>
                                        {
                                            whiseAgents.length > 0 ? whiseAgents.map((item, i) => {
                                                return (
                                                    <option value={item.id} data-agent={JSON.stringify(item)} key={i}>{item.firstName + " " + item.name}</option>
                                                )
                                            })
                                                :
                                                <></>
                                        }
                                    </select>
                                    :
                                    <></>
                        }
                    </div>
                </div>
            </div>

            {/*Hide Purpose Status Change Configuration*/}
            <div className={`row mt-2 mb-4 ${activeTab === "client" ? "" : "d-none"}`}>

                <div className="col-12">
                    <div className="d-flex align-items-center  mb-4">
                        <h2 className="form-title me-2">{reduxLanguageTranslations ? reduxLanguageTranslations["purposeStatusChangeConfiguration"] : "Purpose Status Change Configuration"}</h2>
                        <div
                            onClick={() => setIsToggle(!isToggle)}
                            style={{
                                width: "50px",
                                height: "23px",
                                borderRadius: "999px",
                                backgroundColor: isToggle ? "#27A376" : "#ccc",
                                position: "relative",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                            }}
                        >
                            <div
                                style={{
                                    width: "15px",
                                    height: "15px",
                                    borderRadius: "50%",
                                    backgroundColor: "white",
                                    position: "absolute",
                                    top: "4px",
                                    left: isToggle ? "30px" : "4px",
                                    transition: "left 0.3s cubic-bezier(.34,1.56,.64,1)",
                                }}
                            />
                        </div>
                    </div>

                </div>

                {/*On hold status Config*/}
                <div className="col-6" style={{ opacity: isToggle ? 1 : 0.4, pointerEvents: isToggle ? "auto" : "none" }}>
                    <h6 className="form-title mb-4">{reduxLanguageTranslations ? reduxLanguageTranslations["onHoldStatusConfiguration"] : "On Hold Status Configuration"}</h6>
                    <div className="mb-4">
                        <h6 className="form-group-label mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["statusesTriggerPropertyOnHold"] : "Statuses Triggering “Property On Hold”"}</h6>
                        <div className={`${isUniqueEstatePurposeConfigStatus || onHoldEstateConfigValid ? "border-red-multi-drp" : ""}`}>
                            <MultiSelect
                                id="purposeStatusList"
                                value={selectEstatePurposeStatusListByOnHold.length > 0 ? selectEstatePurposeStatusListByOnHold : []}
                                options={estatePurposeStatusList}
                                onChange={onChangeEstatePurposeStatusByOnHold}
                                labelledBy="Select estate purpose status"
                                overrideStrings={{
                                    search: reduxLanguageTranslations ? reduxLanguageTranslations["searchPlaceholderForMultiSelect"] : "Search",
                                    selectAll: reduxLanguageTranslations ? reduxLanguageTranslations["reactMultiSelectSelectAllLabel"] : "Select All"
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group row align-items-center mb-4">
                        <div className="col-sm-12 col-md-8">
                            <label htmlFor="officeName" className="form-group-label me-2 my-0">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["cancelConfirmedVisitsPropertyOnHold"] : "Cancel Confirmed Visits When Property Is On Hold"}
                            </label>
                        </div>
                        <div className="col-sm-12 col-md-4 d-flex">
                            <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 me-2`} htmlFor={`radioConfirmedVisitCancelYes`}>
                                <input className="custom-radio me-2" type="radio" name={`radioConfirmedVisitCancelOnHold`} id={`radioConfirmedVisitCancelOnHoldYes`} checked={cancelConfirmVisitOnHold === true} onChange={(e) => setCancelConfirmVisitOnHold(previous => !previous)} />
                                {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}
                            </label>
                            <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0`} htmlFor={`radioConfirmedVisitCancelNo`}>
                                <input className="custom-radio me-2" type="radio" name={`radioConfirmedVisitCancelOnHold`} id={`radioConfirmedVisitCancelOnHoldNo`} checked={cancelConfirmVisitOnHold === false} onChange={(e) => setCancelConfirmVisitOnHold(previous => !previous)} />
                                {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}
                            </label>
                        </div>
                    </div>
                    <div className="form-group row align-items-center mb-4">
                        <div className="col-sm-12 col-md-8">
                            <label htmlFor="officeName" className="form-group-label me-2 my-0">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["notifyParticipantsConfirmedCancelledOnHold"] : "Notify Participants When Confirmed Visits Are Cancelled (On Hold)"}
                            </label>
                        </div>
                        <div className="col-sm-12 col-md-4 d-flex">
                            <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 me-2`} htmlFor={`radioConfirmedContactEmailOnHoldYes`}>
                                <input className="custom-radio me-2" type="radio" name={`radioConfirmedContactEmailOnHold`} id={`radioConfirmedContactEmailOnHoldYes`} checked={notifyConfirmedVisitCancelOnHold === true} onChange={(e) => setNotifyConfirmedVisitCancelOnHold(previous => !previous)} />
                                {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}
                            </label>
                            <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0`} htmlFor={`radioConfirmedContactEmailOnHoldNo`}>
                                <input className="custom-radio me-2" type="radio" name={`radioConfirmedContactEmailOnHold`} id={`radioConfirmedContactEmailOnHoldNo`} checked={notifyConfirmedVisitCancelOnHold === false} onChange={(e) => setNotifyConfirmedVisitCancelOnHold(previous => !previous)} />
                                {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}
                            </label>
                        </div>
                    </div>
                    <div className="form-group row align-items-center">
                        <div className="col-sm-12 col-md-8">
                            <label htmlFor="officeName" className="form-group-label me-2 my-0">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["sendEmailNotificationsToWaitingList"] : "Send email notifications to waiting list contacts with 'Enqueue' status?"}
                            </label>
                        </div>
                        <div className="col-sm-12 col-md-4 d-flex">
                            <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 me-2`} htmlFor={`radioEnableEmailSentToContactYes`}>
                                <input className="custom-radio me-2" type="radio" name={`radioEnableEmailSentToContact`} id={`radioEnableEmailSentToContactYes`} checked={enableEmailSentToContact === true} onChange={(e) => setEnableEmailSentToContact(previous => !previous)} />
                                {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}
                            </label>
                            <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0`} htmlFor={`radioEnableEmailSentToContactNo`}>
                                <input className="custom-radio me-2" type="radio" name={`radioEnableEmailSentToContact`} id={`radioEnableEmailSentToContactNo`} checked={enableEmailSentToContact === false} onChange={(e) => setEnableEmailSentToContact(previous => !previous)} />
                                {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}
                            </label>
                        </div>
                    </div>
                </div>

                {/*Deactive status Config*/}
                <div className="col-6" style={{ opacity: isToggle ? 1 : 0.4, pointerEvents: isToggle ? "auto" : "none" }}>
                    <h6 className="form-title mb-4">{reduxLanguageTranslations ? reduxLanguageTranslations["deactivatedStatusConfiguration"] : "Deactivated Status Configuration"}</h6>
                    <div className="mb-4">
                        <h6 className="form-group-label mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["statusesTriggerPropertyDeactivated"] : "Statuses Triggering “Property Deactivated”"}</h6>
                        <div className={`${isUniqueEstatePurposeConfigStatus || deactiveEstateConfigValid ? "border-red-multi-drp" : ""}`}>
                            <MultiSelect
                                id="purposeStatusList"
                                value={selectDeactiveEstatePurposeStatus.length > 0 ? selectDeactiveEstatePurposeStatus : []}
                                options={estatePurposeStatusList}
                                onChange={onChangeEstatePurposeStatusForDeactive}
                                labelledBy="Select estate purpose status"
                                overrideStrings={{
                                    search: reduxLanguageTranslations ? reduxLanguageTranslations["searchPlaceholderForMultiSelect"] : "Search",
                                    selectAll: reduxLanguageTranslations ? reduxLanguageTranslations["reactMultiSelectSelectAllLabel"] : "Select All"
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-group row align-items-center mb-4">
                        <div className="col-sm-12 col-md-8">
                            <label htmlFor="officeName" className="form-group-label me-2 my-0">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["cancelConfirmedVisitsPropertyDeactivated"] : "Cancel Confirmed Visits When Property Is Deactivated"}
                            </label>
                        </div>
                        <div className="col-sm-12 col-md-4 d-flex">
                            <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 me-2`} htmlFor={`radioConfirmedVisitCancelDeactiveYes`}>
                                <input className="custom-radio me-2" type="radio" name={`radioConfirmedVisitCancelDeactive`} id={`radioConfirmedVisitCancelDeactiveYes`} checked={cancelConfirmVisitDeactive === true} onChange={(e) => setCancelConfirmVisitDeactive(previous => !previous)} />
                                {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}
                            </label>
                            <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0`} htmlFor={`radioConfirmedVisitCancelDeactiveNo`}>
                                <input className="custom-radio me-2" type="radio" name={`radioConfirmedVisitCancelDeactive`} id={`radioConfirmedVisitCancelDeactiveNo`} checked={cancelConfirmVisitDeactive === false} onChange={(e) => setCancelConfirmVisitDeactive(previous => !previous)} />
                                {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}
                            </label>
                        </div>
                    </div>
                    <div className="form-group row align-items-center mb-4">
                        <div className="col-sm-12 col-md-8">
                            <label htmlFor="officeName" className="form-group-label me-2 my-0">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["notifyParticipantsConfirmedCancelledDeactivated"] : "Notify Participants When Confirmed Visits Are Cancelled (Deactivated)"}
                            </label>
                        </div>
                        <div className="col-sm-12 col-md-4 d-flex">
                            <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 me-2`} htmlFor={`radioConfirmedContactEmailDeactiveYes`}>
                                <input className="custom-radio me-2" type="radio" name={`radioConfirmedContactEmailDeactive`} id={`radioConfirmedContactEmailDeactiveYes`} checked={notifyConfirmedVisitCancelDeactive === true} onChange={(e) => setNotifyConfirmedVisitCancelDeactive(previous => !previous)} />
                                {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}
                            </label>
                            <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0`} htmlFor={`radioConfirmedContactEmailDeactiveNo`}>
                                <input className="custom-radio me-2" type="radio" name={`radioConfirmedContactEmailDeactive`} id={`radioConfirmedContactEmailDeactiveNo`} checked={notifyConfirmedVisitCancelDeactive === false} onChange={(e) => setNotifyConfirmedVisitCancelDeactive(previous => !previous)} />
                                {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}
                            </label>
                        </div>
                    </div>
                    <div className="form-group row align-items-center">
                        <div className="col-sm-12 col-md-8">
                            <label htmlFor="officeName" className="form-group-label me-2 my-0">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["sendEmailNotificationsToWaitingList"] : "Send email notifications to waiting list contacts with 'Enqueue' status?"}
                            </label>
                        </div>
                        <div className="col-sm-12 col-md-4 d-flex">
                            <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 me-2`} htmlFor={`radioDeactiveEnableEmailSentToContactYes`}>
                                <input className="custom-radio me-2" type="radio" name={`radioDeactiveEnableEmailSentToContact`} id={`radioDeactiveEnableEmailSentToContactYes`} checked={deactiveEnableEmailSentToContact === true} onChange={(e) => setDeactiveEnableEmailSentToContact(previous => !previous)} />
                                {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}
                            </label>
                            <label className={`modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0`} htmlFor={`radioDeactiveEnableEmailSentToContactNo`}>
                                <input className="custom-radio me-2" type="radio" name={`radioDeactiveEnableEmailSentToContact`} id={`radioDeactiveEnableEmailSentToContactNo`} checked={deactiveEnableEmailSentToContact === false} onChange={(e) => setDeactiveEnableEmailSentToContact(previous => !previous)} />
                                {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}
                            </label>
                        </div>
                    </div>
                </div>

                {/*Common Config (On hold & Deactive)*/}
                <div className="mt-5" style={{ opacity: isToggle ? 1 : 0.4, pointerEvents: isToggle ? "auto" : "none" }}>
                    <h5 className="mb-4">{reduxLanguageTranslations ? reduxLanguageTranslations["commonConfigurationOnHoldDeactivated"] : "Common Configuration (On Hold & Deactivated)"}</h5>

                    <div className="row">
                        <div className="col-6">
                            <div className="mb-4">
                                <p className="mb-0 form-group-label mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["crmCalendarActionCancelledVisits"] : "CRM Calendar Action for Cancelled Visits"}</p>
                                <select className={`form-select w-50`} id="visitToSaleFreeSlot" value={cancelVisitCalanderActionId}
                                    onChange={onChangeCancelVisitCalanderActionId}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>

                            {/*Time duration choose for property status change*/}
                            <div className="mb-4" style={{ opacity: isToggle ? 1 : 0.4, pointerEvents: isToggle ? "auto" : "none" }}>
                                <p className="mb-0 form-group-label mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["delayBeforePropertyStatusAutomation"] : "Delay Before Executing Property Status Change Automation (Minutes)"}</p>
                                <select className={`form-select w-50`} id="visitToSaleFreeSlot" value={timeDelayByPropertyStatus}
                                    onChange={onChangeTimeDelayByPropertyStatus}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["chooseTime"] : "Choose the time"}</option>
                                    <option value="5">5 {reduxLanguageTranslations ? reduxLanguageTranslations["minutesShort"] : "min"} </option>
                                    <option value="10">10 {reduxLanguageTranslations ? reduxLanguageTranslations["minutesShort"] : "min"}</option>
                                </select>
                            </div>

                        </div>

                        <div className={`${cancelVisitCalanderActionId && userAccountType == variables.UserAccountTypeIdentity ? "col-6" : "d-none"}`}>
                            {/*Choose Confirmed Visit Backup Method*/}
                            <div className="mb-4" style={{ opacity: isToggle ? 1 : 0.4, pointerEvents: isToggle ? "auto" : "none" }}>
                                <p className="mb-0 form-group-label mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["confirmedVisitBackupMethod"] : "Confirmed Visit Backup Method"}</p>
                                <select className={`form-select w-50`} id="visitToSaleFreeSlot" value={confirmedVisitBackupMethod}
                                    onChange={onChangeConfirmVisitBackupMethod}>
                                    <option value="delete_and_create">{reduxLanguageTranslations ? reduxLanguageTranslations["deleteAndCreate"] : "Delete and Create"} </option>
                                    <option value="update">{reduxLanguageTranslations ? reduxLanguageTranslations["update"] : "Update"}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/*Email send on property status change*/}
                    <div className="mb-4" style={{ opacity: isToggle ? 1 : 0.4, pointerEvents: isToggle ? "auto" : "none" }}>
                        <div className="form-group row align-items-center pt-4">
                            <div className="col-sm-5 col-md-5">
                                <label className={`modal-p-text-black d-flex align-items-center`} htmlFor="propertyStatusNotific">
                                    <input className="form-check-input checkbox-green me-2 mt-0" type="checkbox" checked={isManagePropertyStatusChangeCustomEmail} id="propertyStatusNotific" onChange={checkBoxPropertyStatusToSendEmail} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["recipientsPropertyStatusNotifications"] : "Recipients for Property Status Change Notifications :"}
                                </label>
                            </div>
                            <div className={`col-sm-3 col-md-3 ${isManagePropertyStatusChangeCustomEmail ? "d-block" : "d-none"}`}>
                                <select className={`form-select ${isSelectSpecificEmailEmptyByPropertyStatus}`} id="selectCustomEmail" value={isSelectSpecificEmailByPropertyStatus} onChange={handlerSelectSpecificEmailByPropertyStatus}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageSelectOpt"] : "Select option"}</option>
                                    <option value="1">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageEstateOfficeEmailOpt"] : "Estate office email"}</option>
                                    <option value="2">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageOtherOpt"] : "Other"}</option>
                                </select>
                            </div>
                            <div className={`col-sm-4 col-md-4 ${isManagePropertyStatusChangeCustomEmail && isSelectSpecificEmailByPropertyStatus == 2 ? "d-block" : "d-none"}`}>
                                <input className={`form-control ${isCustomEmailEmptyByPropertyStatus}`} value={isCustomEmailByPropertyStatus} onChange={onChangePropertyStatusCustomEmail} />
                            </div>
                        </div>
                        <div className={`form-group row align-items-center pt-4 ${isManagePropertyStatusChangeCustomEmail ? "d-flex" : "d-none"}`}>
                            {/*<label htmlFor="officeName" className="col-sm-3 form-group-label my-0 justify-content-end">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageExceptionsLbl"] : "Exceptions:"}</label>*/}
                            <div className="col-sm-3 col-md-2">
                                <p className="mb-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageExceptionsLbl"] : "Exceptions:"}</p>
                            </div>
                            <div className="col-sm-3 col-md-3">
                                <select className={`form-select ${isSelectAgentEmptyByPropertyStatus}`} id="agentListByPropertyStatus" value={selectAgentByPropertyStatus} onChange={onChangePropertyStatusSelectAgent}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownAgentSelect"] : "Select Agent"}</option>
                                    {
                                        whiseAgents.length > 0 ? whiseAgents.map((item, i) => {
                                            return (
                                                <option value={item.id} data-agent={JSON.stringify(item)} key={i}>{item.firstName + " " + item.name}</option>
                                            )
                                        })
                                            :
                                            <></>
                                    }
                                </select>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div className={`agency-detail-container row p-4 ${activeTab === "client" ? "" : "d-none"}`}>
                <div className="col-6">
                    <h5 className="mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageAgencyDetailsLbl"] : "Agency Details"}</h5>
                    <p className="mb-0">{reduxLanguageTranslations ? reduxLanguageTranslations["viewManageAgencyInfo"] : "View and manage your agency information"}</p>
                </div>
                <div className="col-6">
                    <div className="text-end">
                        <button className="site-btn-red site-btn-padd" onClick={navigateAgencyTab}>{reduxLanguageTranslations ? reduxLanguageTranslations["viewDetail"] : "View detail"} <img src={rightArrowWhite} alt="right arrow" /></button>
                    </div>
                </div>
            </div>

            <div className="row pt-4 pb-5">
                <div className="col-12 text-center">
                    <button className="site-btn gray-btn" onClick={handlerResetSettings}>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageResetBtnText"] : "Reset"}</button>
                    <button className="site-btn ms-2" onClick={activeTab == "agency" ? saveEstateAndOfficeSetting : handlerSaveSetting}>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSaveBtnText"] : "Save"}</button>
                </div>
            </div>
            <ConfirmSynchronization showConfirmWindow={showConfirmationModel} handleConfirmWindowClose={handleConfirmWindowClose} callBackConfirmSyncOfFreeSlots={callBackConfirmSyncOfFreeSlots} messageLocalToWHise={modalMessageLocalToWhiseSync} messageWhiseToLocal={modalMessageWhiseToLocalSync} />
            <WaitingListEnabledWindow showConfirmWindow={waitingModalShow} handleConfirmWindowClose={handleWaitingAlertClose} messageShow={waitingAlertMessage} isWaitingListEnabled={isWaitingListEnabled} setIsWaitingListEnabled={setIsWaitingListEnabled} />
        </div>
    )
}